// Source of truth: swau-auth-dash/authShopify/verifyHologram.js — copy to repo root after edits.
// Every class emitted here is styled by templates/page.verify-hologram.liquid in swau-shopify-auth
// (Prestige). The old Flow template in authShopify does not carry these styles.
// theme-check-disable
(function() {
    // Hide the form immediately if a ?id= param is present, preventing a flash before the loading spinner appears
    if (typeof URLSearchParams !== 'undefined' && new URLSearchParams(window.location.search).has('id')) {
      var _noFlashStyle = document.createElement('style');
      _noFlashStyle.id = 'swau-no-flash';
      _noFlashStyle.textContent = '.swau-card { display: none !important; }';
      (document.head || document.documentElement).appendChild(_noFlashStyle);
    }

    function initSWAUAuth() {
      // API Configuration
      const API_BASE_URL = 'https://auth-dash.swau.com/api'; // Change this to your App Runner URL when deployed
      // Shared links go through app.swau.com so previews carry the grade image; visitors land back here.
      const SHARE_BASE_URL = 'https://app.swau.com/reveal/';

      // /public/thumb only proxies these buckets (services/publicThumb.js in auth-dash).
      var THUMB_HOSTS = [
        'authentication-images.s3.us-east-2.amazonaws.com',
        'swau-completed-slab-images.s3.us-east-2.amazonaws.com',
        'swau-card-slabs.s3.us-east-2.amazonaws.com',
        'swau-verification-images.s3.us-east-2.amazonaws.com'
      ];
      // The registry sweep stays up at least this long so a fast lookup still reads as a check.
      var MIN_SWEEP_MS = 900;
      var REDUCED_MOTION = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      var TONE_COLORS = {
        gold: '#fbbf24', violet: '#a78bfa', sky: '#7dd3fc', silver: '#e2e8f0',
        slate: '#94a3b8', rose: '#fb7185', emerald: '#34d399', amber: '#f59e0b'
      };
      var DEFAULT_TITLE = document.title;

      // ?id=CERT&reveal=1 (the "your item is ready" email) holds the result behind a tap-to-reveal seal.
      var REVEAL_MODE = typeof URLSearchParams !== 'undefined'
        && new URLSearchParams(window.location.search).get('reveal') === '1';
      var REVEAL_CHARGE_MS = 1800;
      var SOUND_KEY = 'swau_reveal_sound';

      var loadingStartedAt = 0;
      var resultTimer = null;
      var pendingTone = null;
      var pendingTitle = '';
      var revealState = null;

      var ICONS = {
        check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 12.75l6 6 9-13.5"/></svg>',
        share: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 8.25H7.5a2.25 2.25 0 00-2.25 2.25v9a2.25 2.25 0 002.25 2.25h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25H15m0-3l-3-3m0 0l-3 3m3-3V15"/></svg>',
        download: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"/></svg>',
        arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M13.5 4.5L21 12l-7.5 7.5M21 12H3"/></svg>',
        search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4.2-4.2"/></svg>',
        shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"/></svg>',
        alert: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"/></svg>',
        cross: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 18L18 6M6 6l12 12"/></svg>',
        clock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>',
        cloud: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.25 15a4.5 4.5 0 004.5 4.5H18a3.75 3.75 0 001.332-7.257 3 3 0 00-3.758-3.848 5.25 5.25 0 00-10.233 2.33A4.502 4.502 0 002.25 15z"/></svg>',
        prev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15.75 19.5L8.25 12l7.5-7.5"/></svg>',
        next: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8.25 4.5l7.5 7.5-7.5 7.5"/></svg>',
        link: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M13.19 8.47a5.25 5.25 0 00-7.42 0l-2.12 2.12a5.25 5.25 0 107.42 7.42l.59-.59m4.16-7.83a5.25 5.25 0 017.42 0l.59.59m-11.17 4.72a5.25 5.25 0 007.42 0l2.12-2.12"/></svg>',
        story: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 8.25h3"/></svg>',
        x: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>',
        facebook: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.413c0-3.026 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.971H15.83c-1.491 0-1.956.93-1.956 1.886v2.264h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/></svg>',
        replay: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"/></svg>'
      };

    // ── Reveal sound (same synth as the SWAU Rips reveal) ─────────────────────

    var audioCtx = null;

    function soundOn() {
      try { return localStorage.getItem(SOUND_KEY) !== '0'; } catch (e) { return true; }
    }

    // iOS only lets an AudioContext start inside a tap handler.
    function unlockAudio() {
      var AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return;
      if (!audioCtx) audioCtx = new AC();
      if (audioCtx.state === 'suspended') audioCtx.resume().catch(function () {});
      var source = audioCtx.createBufferSource();
      source.buffer = audioCtx.createBuffer(1, 1, 22050);
      source.connect(audioCtx.destination);
      source.start(0);
    }

    function readyAudio() {
      return audioCtx && audioCtx.state === 'running' && soundOn() ? audioCtx : null;
    }

    function playTone(audio, freq, start, duration, gain, type) {
      var osc = audio.createOscillator();
      var amp = audio.createGain();
      osc.type = type || 'sine';
      osc.frequency.value = freq;
      amp.gain.setValueAtTime(0.0001, start);
      amp.gain.exponentialRampToValueAtTime(gain, start + 0.008);
      amp.gain.exponentialRampToValueAtTime(0.0001, start + duration);
      osc.connect(amp);
      amp.connect(audio.destination);
      osc.start(start);
      osc.stop(start + duration + 0.02);
    }

    function playLand(level) {
      var audio = readyAudio();
      if (!audio) return;
      var t = audio.currentTime;
      playTone(audio, 880, t, 0.7, 0.07);
      playTone(audio, 1318.5, t + 0.08, 0.8, 0.06);
      if (level >= 1) playTone(audio, 1760, t + 0.16, 1.1, 0.05);
      if (level >= 2) {
        playTone(audio, 110, t, 0.9, 0.12);
        playTone(audio, 2217.5, t + 0.26, 1.2, 0.035);
      }
      if (level >= 3) {
        [1046.5, 1318.5, 1568, 2093].forEach(function (f, i) { playTone(audio, f, t + 0.42 + i * 0.09, 1.3, 0.045, 'triangle'); });
        playTone(audio, 65.4, t + 0.42, 1.4, 0.14);
      }
    }

    function playWhoosh() {
      var audio = readyAudio();
      if (!audio) return;
      var t = audio.currentTime;
      var length = Math.floor(audio.sampleRate * 0.6);
      var buffer = audio.createBuffer(1, length, audio.sampleRate);
      var data = buffer.getChannelData(0);
      for (var i = 0; i < length; i++) data[i] = Math.random() * 2 - 1;
      var source = audio.createBufferSource();
      source.buffer = buffer;
      var filter = audio.createBiquadFilter();
      filter.type = 'bandpass';
      filter.Q.value = 0.8;
      filter.frequency.setValueAtTime(350, t);
      filter.frequency.exponentialRampToValueAtTime(3200, t + 0.5);
      var amp = audio.createGain();
      amp.gain.setValueAtTime(0.0001, t);
      amp.gain.exponentialRampToValueAtTime(0.09, t + 0.12);
      amp.gain.exponentialRampToValueAtTime(0.0001, t + 0.6);
      source.connect(filter);
      filter.connect(amp);
      amp.connect(audio.destination);
      source.start(t);
      source.stop(t + 0.62);
    }

    ensureDefectPulseStyles();

    // ── Page state ────────────────────────────────────────────────────────────

    function pageEl() {
      return document.querySelector('.swau-verify-page');
    }

    function setTone(tone, level) {
      var page = pageEl();
      if (!page) return;
      page.setAttribute('data-tone', tone || 'silver');
      page.setAttribute('data-level', String(level || 0));
    }

    // While a lookup or result is on screen the Prestige header steps aside for the slim bar.
    function setResultMode(on, label) {
      document.body.classList.toggle('swau-verify-has-result', !!on);
      $('[data-vx-cert]').text(on && label ? label : '');
      $('[data-vx-loading-cert]').text(on && label ? label : '');
    }

    function setIdParam(value) {
      if (!window.history || !window.history.replaceState || typeof URLSearchParams === 'undefined') return;
      var params = new URLSearchParams(window.location.search);
      params.delete('reveal');
      if (value) params.set('id', value);
      else params.delete('id');
      var query = params.toString();
      window.history.replaceState(null, '', window.location.pathname + (query ? '?' + query : ''));
    }

    function now() {
      return window.performance && performance.now ? performance.now() : Date.now();
    }

    function lookupLabel(raw) {
      var value = String(raw || '').trim();
      if (value.charAt(0) === '#') return 'Order #' + value.substring(1).trim();
      value = value.replace(/\s+/g, '').toUpperCase();
      return value ? '#' + value : '';
    }

    // ── Formatting helpers ────────────────────────────────────────────────────

    function escapeHtml(str) {
      if (str == null) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function titleCase(str) {
      return String(str || '').toLowerCase().replace(/(^|[\s(\/-])([a-z])/g, function (m, pre, ch) {
        return pre + ch.toUpperCase();
      });
    }

    function isNumericGrade(value) {
      return /^\d+(\.\d+)?$/.test(String(value == null ? '' : value).trim());
    }

    function makeGrade(key, label, value) {
      var v = String(value == null ? '' : value).trim();
      var numeric = isNumericGrade(v);
      if (!numeric) v = v.toUpperCase();
      return { key: key, label: label, value: v, name: titleCase(gradeLabelFromGrade(v)), numeric: numeric };
    }

    function headlineGrade(grades) {
      for (var i = 0; i < grades.length; i++) {
        if (grades[i].key === 'autograph') return grades[i];
      }
      return grades[grades.length - 1] || null;
    }

    // Same tiers as the SWAU Reveal page on app.swau.com, so a reveal and its verify page match.
    function toneForGrades(grades) {
      var best = null;
      for (var i = 0; i < grades.length; i++) {
        if (grades[i].numeric) best = Math.max(best == null ? 0 : best, parseFloat(grades[i].value));
      }
      if (best != null) {
        if (best >= 10) return { tone: 'gold', level: 3 };
        if (best >= 9) return { tone: 'violet', level: 2 };
        if (best >= 8) return { tone: 'sky', level: 1 };
        if (best >= 7) return { tone: 'silver', level: 0 };
        return { tone: 'slate', level: 0 };
      }
      var authentic = !grades.length || grades.some(function (g) { return g.value === 'A'; });
      return authentic ? { tone: 'gold', level: 2 } : { tone: 'sky', level: 1 };
    }

    function gradeSummary(grades) {
      return grades.map(function (g) {
        var name = g.key === 'autograph' ? 'Auto' : g.label;
        return g.numeric ? name + ' ' + g.value + ' ' + g.name : name + ' ' + g.name;
      }).join(' · ');
    }

    function joinNames(names) {
      if (names.length <= 1) return names[0] || '';
      if (names.length === 2) return names[0] + ' & ' + names[1];
      return names.slice(0, -1).join(', ') + ' & ' + names[names.length - 1];
    }

    function isHttp(url) {
      return typeof url === 'string' && /^https?:\/\//i.test(url);
    }

    function uniquePhotos(list) {
      var seen = {};
      var out = [];
      for (var i = 0; i < list.length; i++) {
        var url = list[i];
        if (isHttp(url) && !seen[url]) {
          seen[url] = true;
          out.push(url);
        }
      }
      return out;
    }

    function thumbFor(src) {
      try {
        var host = new URL(src).hostname;
        return THUMB_HOSTS.indexOf(host) !== -1 ? API_BASE_URL + '/public/thumb?u=' + encodeURIComponent(src) : '';
      } catch (e) {
        return '';
      }
    }

    function fileNameFor(url) {
      return String(url || '').split('?')[0].split('/').slice(-2).join('_');
    }

    function logoSVG() {
      var logo = document.querySelector('.vx-bar__logo .vx-logo');
      return logo ? logo.outerHTML : '';
    }

    function formatVerificationResult(result) {
      switch(result) {
        case 'likely_genuine': return 'Likely Genuine';
        case 'not_likely_genuine': return 'Not Likely Genuine';
        case 'unable_to_render': return 'Unable to Render Opinion';
        case 'likely_authentic': return 'Likely Authentic';
        case 'likely_altered': return 'Likely Altered';
        case 'not_likely_authentic': return 'Not Likely Authentic';
        default: return result;
      }
    }

    var FUNKO_ISSUE_TEXT = {
      sticker_swapped: 'Likely sticker swapped',
      window_swapped: 'Likely window swapped',
      box_swapped: 'Likely box swapped',
      custom_made: 'Custom made'
    };

    function verdictKind(result) {
      switch(result) {
        case 'likely_genuine':
        case 'likely_authentic':
        case 'appraisal':
          return 'pass';
        case 'not_likely_genuine':
        case 'not_likely_authentic':
          return 'fail';
        case 'unable_to_render':
        case 'likely_altered':
          return 'warn';
        default: return 'neutral';
      }
    }

    function ensureDefectPulseStyles() {
      if (document.getElementById('swau-defect-pulse-styles')) return;
      var styleEl = document.createElement('style');
      styleEl.id = 'swau-defect-pulse-styles';
      styleEl.textContent =
        '.defect-card-img-wrap{overflow:visible!important;}' +
        '.defect-card-img-inner{overflow:hidden;border-radius:8px;line-height:0;}' +
        '.defect-card-images,.defect-card-side{overflow:visible!important;}' +
        '.defect-marker{' +
        'animation:swauDefectPulse 2.2s ease-in-out infinite;' +
        '}' +
        '.defect-marker::after{' +
        'content:"";position:absolute;inset:-5px;border-radius:999px;' +
        'border:2px solid rgba(255,59,48,0.35);' +
        'animation:swauDefectRing 2.2s ease-out infinite;' +
        'pointer-events:none;' +
        '}' +
        '@keyframes swauDefectPulse{' +
        '0%,100%{transform:translate(-50%,-50%) scale(1);}' +
        '50%{transform:translate(-50%,-50%) scale(1.08);}' +
        '}' +
        '@keyframes swauDefectRing{' +
        '0%{opacity:.55;transform:scale(0.9);}' +
        '70%{opacity:0;transform:scale(1.28);}' +
        '100%{opacity:0;transform:scale(1.28);}' +
        '}';
      (document.head || document.documentElement).appendChild(styleEl);
    }

    // Push overlapping defect markers apart while tethering each to its real defect location.
    // MIN_SEP: minimum center-to-center distance between any two markers (image-space, 0..1).
    // MAX_DRIFT: hard cap on how far a marker can move from its true defect coordinate.
    function computeDefectMarkerPositions(sideDefects) {
      var MIN_SEP = 0.06;
      var MAX_DRIFT = 0.045;
      var MAX_ITERS = 60;

      var points = sideDefects.map(function (d, i) {
        return {
          id: d.id != null ? d.id : i + 1,
          ox: d.location.x,
          oy: d.location.y,
          x: d.location.x,
          y: d.location.y
        };
      });

      for (var iter = 0; iter < MAX_ITERS; iter++) {
        var moved = false;

        for (var i = 0; i < points.length; i++) {
          for (var j = i + 1; j < points.length; j++) {
            var dx = points[j].x - points[i].x;
            var dy = points[j].y - points[i].y;
            var dist = Math.sqrt(dx * dx + dy * dy);
            if (dist >= MIN_SEP) continue;

            if (dist < 1e-4) {
              dx = 0;
              dy = 1;
              dist = 0;
            } else {
              dx /= dist;
              dy /= dist;
            }

            var push = (MIN_SEP - dist) / 2 + 1e-4;
            points[i].x -= dx * push;
            points[i].y -= dy * push;
            points[j].x += dx * push;
            points[j].y += dy * push;
            moved = true;
          }
        }

        for (var k = 0; k < points.length; k++) {
          var p = points[k];
          var ddx = p.x - p.ox;
          var ddy = p.y - p.oy;
          var drift = Math.sqrt(ddx * ddx + ddy * ddy);
          if (drift > MAX_DRIFT) {
            var s = MAX_DRIFT / drift;
            p.x = p.ox + ddx * s;
            p.y = p.oy + ddy * s;
          }
        }

        if (!moved) break;
      }

      return points.map(function (p) {
        return { id: p.id, x: p.x, y: p.y };
      });
    }

    // ── Shared result pieces ──────────────────────────────────────────────────

    function badgesHTML(badges) {
      return badges.filter(Boolean).map(function (b) {
        return '<span class="vx-badge' + (b.kind ? ' vx-badge--' + b.kind : '') + '">'
             + (b.icon ? ICONS[b.icon] : '') + escapeHtml(b.text) + '</span>';
      }).join('');
    }

    function gradesHTML(grades) {
      var headline = headlineGrade(grades);
      var single = grades.length === 1;
      var html = '<div class="vx-grades vx-rise" style="--d:360ms">';
      html += '<div class="vx-grades__inner" style="--vx-cols:' + grades.length + '">';
      for (var i = 0; i < grades.length; i++) {
        var g = grades[i];
        var isHead = g === headline;
        // Supporting grades land first so the headline grade is the last hit.
        var delay = isHead ? (single ? 650 : 950) : 550;
        html += '<div class="vx-grade' + (isHead ? ' vx-grade--headline' : '') + '">';
        html += '<p class="vx-grade__label">' + escapeHtml(g.label) + '</p>';
        html += '<div class="vx-grade__slam" style="--d:' + delay + 'ms">';
        if (isHead) html += '<span class="vx-grade__ring" style="--d:' + (delay + 300) + 'ms" aria-hidden="true"></span>';
        html += '<p class="vx-grade__value">' + escapeHtml(g.value) + '</p>';
        html += '</div>';
        if (g.name) html += '<p class="vx-grade__name">' + escapeHtml(g.name) + '</p>';
        if (g.score) {
          html += '<p class="vx-grade__score"' + (g.scoreTitle ? ' title="' + escapeHtml(g.scoreTitle) + '"' : '') + '>'
               + escapeHtml(g.score) + '</p>';
        }
        html += '</div>';
      }
      html += '</div></div>';
      return html;
    }

    function factsHTML(facts, delay) {
      var list = (facts || []).filter(function (f) {
        return f && f.value != null && String(f.value).trim() !== '';
      });
      if (!list.length) return '';
      // A cell left alone on its row stretches across, so the grid never shows a hole.
      var col = 0;
      var cells = list.map(function (f, i) {
        var next = list[i + 1];
        var wide = !!f.wide || (col === 0 && (!next || next.wide));
        col = wide ? 0 : (col + 1) % 2;
        return '<div' + (wide ? ' class="is-wide"' : '') + '><dt>' + escapeHtml(f.label) + '</dt>'
             + '<dd' + (f.mono ? ' class="is-mono"' : '') + '>' + escapeHtml(f.value) + '</dd></div>';
      });
      var rise = delay != null ? ' vx-rise" style="--d:' + delay + 'ms"' : '"';
      return '<dl class="vx-facts' + rise + '>' + cells.join('') + '</dl>';
    }

    function stageHTML(photos, title, cert) {
      var many = photos.length > 1;
      var html = '<div class="vx-stage" data-index="0">';
      html += '<div class="vx-stage__flip"><div class="vx-stage__frame"><div class="vx-stage__inner">';
      if (!photos.length) {
        html += '<div class="vx-placeholder">' + logoSVG();
        html += '<div class="vx-placeholder__seal"><span>' + ICONS.shield + '</span></div>';
        html += '<p class="vx-placeholder__label">Certificate of<br>authenticity</p>';
        html += '<p class="vx-placeholder__cert">#' + escapeHtml(cert) + '</p>';
        html += '</div>';
      } else {
        html += '<div class="vx-stage__track">';
        for (var i = 0; i < photos.length; i++) {
          var src = photos[i];
          var preview = thumbFor(src) || src;
          html += '<figure class="vx-slide" data-full="' + escapeHtml(src) + '">';
          html += '<img class="vx-slide__bg" src="' + escapeHtml(preview) + '" alt="" aria-hidden="true" decoding="async">';
          html += '<span class="vx-slide__wash" aria-hidden="true"></span>';
          html += '<img class="vx-slide__img" src="' + escapeHtml(preview) + '" alt="'
               + escapeHtml(title + ', photo ' + (i + 1) + ' of ' + photos.length) + '" decoding="async" draggable="false">';
          html += '</figure>';
        }
        html += '</div>';
        if (many) {
          html += '<button type="button" class="vx-stage__nav vx-stage__nav--prev" data-vx-step="-1" aria-label="Previous photo">' + ICONS.prev + '</button>';
          html += '<button type="button" class="vx-stage__nav vx-stage__nav--next" data-vx-step="1" aria-label="Next photo">' + ICONS.next + '</button>';
        }
      }
      html += '<div class="vx-stage__holo" aria-hidden="true"></div>';
      html += '</div></div></div>';
      if (many) {
        html += '<div class="vx-dots">';
        for (var d = 0; d < photos.length; d++) {
          html += '<button type="button" class="vx-dot-btn" data-vx-go="' + d + '" aria-label="Show photo ' + (d + 1) + '"'
               + (d === 0 ? ' aria-current="true"' : '') + '><span></span></button>';
        }
        html += '</div>';
      }
      html += '</div>';
      return html;
    }

    // Slides open on the 480px feed thumb, then swap to the camera original once it has loaded.
    function hydrateStages(root, fillWide) {
      $(root).find('.vx-stage').each(function () {
        var stage = this;
        var track = stage.querySelector('.vx-stage__track');
        if (!track) return;
        var slides = Array.prototype.slice.call(track.querySelectorAll('.vx-slide'));
        var dots = Array.prototype.slice.call(stage.querySelectorAll('.vx-dot-btn'));

        slides.forEach(function (slide, index) {
          var img = slide.querySelector('.vx-slide__img');
          var bg = slide.querySelector('.vx-slide__bg');
          var full = slide.getAttribute('data-full');
          function measure() {
            if (img.naturalWidth <= img.naturalHeight * 1.15) return;
            // Landscape slab shots fill the portrait frame since the slab is centered; hologram photos are never cropped,
            // so the frame turns landscape for them instead.
            if (fillWide) slide.classList.add('is-wide');
            else if (index === 0) stage.classList.add('is-landscape');
          }
          img.addEventListener('load', measure);
          if (img.complete && img.naturalWidth) measure();
          img.addEventListener('error', function () {
            if (img.getAttribute('src') !== full) img.src = full;
          });
          bg.addEventListener('error', function () {
            bg.style.display = 'none';
          });
        });

        function upgrade(i) {
          var slide = slides[i];
          if (!slide || slide.hasAttribute('data-upgraded')) return;
          slide.setAttribute('data-upgraded', '');
          var img = slide.querySelector('.vx-slide__img');
          var full = slide.getAttribute('data-full');
          if (img.getAttribute('src') === full) return;
          var loader = new Image();
          loader.onload = function () { img.src = full; };
          loader.src = full;
        }

        function setIndex(i) {
          stage.setAttribute('data-index', String(i));
          dots.forEach(function (dot, n) {
            if (n === i) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          upgrade(i);
        }

        function go(i) {
          var next = (i + slides.length) % slides.length;
          track.scrollTo({ left: next * track.clientWidth, behavior: REDUCED_MOTION ? 'auto' : 'smooth' });
        }

        upgrade(0);
        track.addEventListener('scroll', function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (String(i) !== stage.getAttribute('data-index')) setIndex(i);
        }, { passive: true });

        stage.addEventListener('click', function (e) {
          var target = e.target.closest('[data-vx-go], [data-vx-step]');
          if (!target) return;
          if (target.hasAttribute('data-vx-go')) go(Number(target.getAttribute('data-vx-go')));
          else go(Number(stage.getAttribute('data-index') || 0) + Number(target.getAttribute('data-vx-step')));
        });
      });
    }

    function actionsHTML(canShare, hasPhotos) {
      if (!canShare && !hasPhotos) return '';
      var html = '<div class="vx-actions vx-rise" style="--d:620ms">';
      if (canShare) html += '<button type="button" class="vx-btn vx-btn--primary" data-vx-share>' + ICONS.share + 'Share</button>';
      if (hasPhotos) html += '<button type="button" class="vx-btn vx-btn--glass" data-vx-download>' + ICONS.download + 'Download photo</button>';
      if (revealState) {
        html += '<button type="button" class="vx-btn vx-btn--glass vx-btn--icon" data-vx-replay aria-label="Replay the reveal" title="Replay">'
             + ICONS.replay + '</button>';
      }
      html += '</div>';
      return html;
    }

    function closingHTML() {
      var now = new Date();
      var day = now.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
      var time = now.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
      var html = '<aside class="vx-cta vx-rise" style="--d:700ms">';
      html += '<div>';
      html += '<h2 class="vx-cta__title">Get your items authenticated</h2>';
      html += '<p class="vx-cta__text">Autographs, trading cards, and Funko POPs, by mail-in or online. Every item gets a permanent SWAU record like this one.</p>';
      html += '</div>';
      html += '<a class="vx-btn vx-btn--primary" href="/pages/submit">Submit your items' + ICONS.arrow + '</a>';
      html += '</aside>';
      // Short form on phones so the note stays on one line.
      html += '<p class="vx-note">'
           + '<span class="vx-note__long">Checked live against the SWAU registry on ' + escapeHtml(day + ', ' + time) + '. </span>'
           + '<span class="vx-note__short">Checked live ' + escapeHtml(day) + '. </span>'
           + '<a href="/pages/contact">Something look wrong?</a></p>';
      html += '<div class="vx-again"><button type="button" class="verify-another-item-btn vx-btn vx-btn--ghost">'
           + ICONS.search + 'Verify another item</button></div>';
      return html;
    }

    /**
     * One layout for every certificate: verdict, name, and grade first, the item photo
     * next, then the record and the deep detail for anyone who wants it.
     */
    function verdictHTML(v) {
      var html = '<div class="vx-certified vx-rise" style="--d:360ms">';
      html += '<div class="vx-certified__mark" style="--d:650ms">'
           + '<span class="vx-grade__ring" style="--d:950ms" aria-hidden="true"></span>' + ICONS[v.icon || 'check'] + '</div>';
      html += '<div class="vx-certified__text"><p class="vx-certified__value">' + escapeHtml(v.value) + '</p>';
      if (v.meta) html += '<p class="vx-certified__meta">' + escapeHtml(v.meta) + '</p>';
      html += '</div></div>';
      return html;
    }

    function resultHTML(o) {
      var hasPhotos = !!(o.photos && o.photos.length);
      var cls = 'vx is-revealing' + (o.variant ? ' vx--' + o.variant : '') + (hasPhotos ? '' : ' vx--no-photo');
      var html = '<article class="' + cls + '" data-cert="' + escapeHtml(o.cert) + '"'
               + ' data-kind="' + escapeHtml(o.kind || '') + '" data-grade="' + escapeHtml(o.gradeSummary || '') + '"'
               + ' data-share-title="' + escapeHtml(o.shareTitle || '') + '"'
               + ' data-share-text="' + escapeHtml(o.shareText || '') + '">';
      html += '<div class="vx-hero">';

      html += '<header class="vx-hero__head">';
      var badges = badgesHTML(o.badges || []);
      if (badges) html += '<div class="vx-badges vx-rise" style="--d:150ms">' + badges + '</div>';
      html += '<h1 class="vx-title vx-rise" style="--d:230ms" tabindex="-1">' + escapeHtml(o.title) + '</h1>';
      var lines = (o.subLines || []).filter(Boolean);
      if (lines.length) {
        html += '<p class="vx-sub vx-rise" style="--d:300ms">'
             + lines.map(function (line) { return '<span class="vx-sub__line">' + line + '</span>'; }).join('')
             + '</p>';
      }
      if (o.verdict) html += verdictHTML(o.verdict);
      else if (o.grades && o.grades.length) html += gradesHTML(o.grades);
      html += '</header>';

      html += '<div class="vx-hero__media vx-rise" style="--d:60ms">' + stageHTML(o.photos || [], o.title, o.cert) + '</div>';

      html += '<div class="vx-hero__body">';
      if (o.subgradesHTML) html += o.subgradesHTML;
      html += factsHTML(o.facts, 540);
      html += actionsHTML(!!o.cert, hasPhotos);
      html += '</div>';

      html += '</div>';
      if (o.details) html += '<div class="vx-details">' + o.details + '</div>';
      html += closingHTML();
      html += '</article>';
      return html;
    }

    function ordinalHtml(n) {
      var s = ['th','st','nd','rd'], v = n % 100;
      var suffix = s[(v - 20) % 10] || s[v] || s[0];
      return n + '<sup>' + suffix + '</sup>';
    }

    function populationHTML(p) {
      var hasPop = p.pop != null || p.higher != null || p.total != null;
      var hasRank = p.mintRank != null || p.overallRank != null;
      if (!hasPop && !hasRank) return '';

      function stat(valueHtml, label) {
        return '<div class="vx-stat"><p class="vx-stat__value">' + valueHtml + '</p>'
             + '<p class="vx-stat__label">' + escapeHtml(label) + '</p></div>';
      }
      function count(n) {
        return n != null ? escapeHtml(String(n)) : '—';
      }

      var asOf = new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
      var html = '<section class="vx-section">';
      html += '<h2 class="vx-section__title">' + (hasRank ? 'Population & rank' : 'Population')
           + ' <span class="vx-section__meta">as of ' + escapeHtml(asOf) + '</span></h2>';
      if (hasPop) {
        html += '<div class="vx-stats">';
        html += stat(count(p.pop), (p.gradeName ? p.gradeName + ' graded' : 'At this grade'));
        html += stat(count(p.higher), 'Graded higher');
        html += stat(count(p.total), 'Total graded');
        html += '</div>';
      }
      if (hasRank) {
        var cells = [];
        // mintRank ranks this copy against others at the same grade, not against Mint copies.
        if (p.mintRank != null) cells.push(stat(ordinalHtml(p.mintRank), p.gradeName ? 'Among ' + p.gradeName : 'At this grade'));
        if (p.overallRank != null) cells.push(stat(ordinalHtml(p.overallRank), 'Overall'));
        html += '<p class="vx-section__sub">Card rank</p>';
        html += '<div class="vx-stats" style="--vx-cols:' + cells.length + '">' + cells.join('') + '</div>';
      }
      html += '</section>';
      return html;
    }

    function popFact(pop, total) {
      if (pop != null && total != null) return pop + ' of ' + total;
      if (total != null) return String(total);
      return '';
    }

    // ── Hologram (autograph) record ───────────────────────────────────────────

    /**
     * Witnessed / private-signing holograms record where the auto was signed.
     * Mail-in authentications typically have a cert date and no location.
     */
    function isWitnessHologram(record) {
      if (!record) return false;
      if (record.location && String(record.location).trim()) return true;
      return /witness/i.test(String(record.type || ''));
    }

    function buildHologramRecordHTML(response) {
      var first = response[0] || {};
      var cert = String(first.hologramNumber || '').toUpperCase();
      var signers = response.filter(function (r) { return r && r.name; });
      var names = [];
      signers.forEach(function (s) {
        var name = String(s.name).trim();
        if (name && names.indexOf(name) === -1) names.push(name);
      });
      var photos = [];
      response.forEach(function (r) {
        photos = photos.concat(Array.isArray(r.photo) ? r.photo : [r.photo]);
      });
      photos = uniquePhotos(photos);

      var witnessed = isWitnessHologram(first) || signers.some(isWitnessHologram);
      var title = !names.length
        ? (first.type || 'SWAU authenticated item')
        : names.length <= 3 ? joinNames(names) : names[0] + ' + ' + (names.length - 1) + ' more';
      var grades = [makeGrade('autograph', names.length > 1 ? 'Autographs' : 'Autograph', 'A')];
      var single = signers.length === 1 ? signers[0] : null;

      var facts = [
        { label: 'Cert', value: cert, mono: true },
        { label: 'Certified', value: first.date },
        { label: 'Item', value: first.type },
        names.length > 1 ? { label: 'Signatures', value: String(names.length) } : null
      ];
      if (single) {
        facts.push(
          { label: 'Location', value: single.location },
          { label: 'Character', value: single.characterName },
          { label: 'Personalization', value: single.personalization },
          { label: 'Inscription', value: single.quote, wide: true },
          { label: 'Notes', value: single.notes, wide: true }
        );
      }

      var details = '';
      if (signers.length > 1) {
        details += '<section class="vx-section"><h2 class="vx-section__title">Signature record</h2><div class="vx-sigs">';
        signers.forEach(function (s, i) {
          details += '<div class="vx-sig"><div class="vx-sig__head">';
          details += '<span class="vx-sig__num">' + (i + 1) + '</span>';
          details += '<p class="vx-sig__name">' + escapeHtml(s.name) + '</p>';
          details += '</div>';
          details += factsHTML([
            !witnessed && s.date && s.date !== first.date ? { label: 'Authenticated', value: s.date } : null,
            { label: 'Location', value: s.location },
            { label: 'Character', value: s.characterName },
            { label: 'Personalization', value: s.personalization },
            { label: 'Inscription', value: s.quote, wide: true },
            { label: 'Notes', value: s.notes, wide: true }
          ]);
          details += '</div>';
        });
        details += '</div></section>';
      }

      var itemNoun = first.type ? ' ' + String(first.type).toLowerCase() : '';
      var subLines = names.length && first.type ? [escapeHtml(first.type)] : [];
      // The title shortens past three signers, so the rest are listed under it.
      if (names.length > 3) subLines.push('<span class="vx-sub__names">With ' + escapeHtml(joinNames(names.slice(1))) + '</span>');
      var count = names.length > 1 ? names.length + ' autographs' : 'Autograph';
      var verdictMeta = !names.length ? 'Verified by SWAU'
        : witnessed ? (names.length > 1 ? count + ', signed in person and witnessed by SWAU' : 'Signed in person, witnessed by SWAU')
        : count + ' verified by SWAU';
      return {
        html: resultHTML({
          variant: 'autograph',
          kind: 'hologram',
          gradeSummary: 'SWAU Authentic',
          cert: cert,
          title: title,
          subLines: subLines,
          verdict: { value: 'Authentic', meta: verdictMeta },
          grades: grades,
          photos: photos,
          facts: facts,
          details: details,
          shareTitle: title + ' · SWAU Authentic',
          shareText: title + itemNoun + ', verified authentic by SWAU. Cert #' + cert + '.'
        }),
        tone: toneForGrades(grades),
        title: title + ' · SWAU Authentic | SWAU',
        fillWide: false
      };
    }

    // ── Online verification results (order lookup) ────────────────────────────

    function buildVerificationResultsHTML(verifications, orderNumber) {
      var kinds = [];
      var verdicts = [];
      var cards = '';

      for (var i = 0; i < verifications.length; i++) {
        var v = verifications[i];
        var isAppraisal = v.type === 'appraisal';
        var isFunko = v.type === 'funko_verification';
        var result = v.response ? v.response.result : 'pending';
        var kind = verdictKind(isAppraisal ? 'appraisal' : result);
        kinds.push(kind);
        verdicts.push(isAppraisal ? 'Appraised' : result === 'pending' ? 'Pending' : formatVerificationResult(result));
        var submittedAt = v.response && v.response.submittedAt
          ? new Date(v.response.submittedAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
          : '';
        var funkoIssues = isFunko && v.response && v.response.issues
          ? v.response.issues.map(function (key) { return FUNKO_ISSUE_TEXT[key] || key; })
          : [];
        var funkoAutograph = isFunko && v.response && v.response.autographResult
          ? formatVerificationResult(v.response.autographResult)
          : '';
        var verdict = isAppraisal ? 'Appraisal complete' : (result === 'pending' ? 'Pending' : formatVerificationResult(result));
        var kindLabel = isAppraisal ? 'Appraisal' : isFunko ? 'Funko POP verification' : 'Autograph verification';
        var photos = uniquePhotos(v.photos || []);
        var name = v.celebrityName || '';

        cards += '<section class="vx-result vx-result--' + kind + (photos.length ? '' : ' vx-result--no-photo')
               + ' vx-rise" style="--d:' + (220 + i * 90) + 'ms">';
        if (photos.length) cards += '<div class="vx-result__media">' + stageHTML(photos, name || kindLabel, '') + '</div>';
        cards += '<div class="vx-result__body">';
        cards += '<p class="vx-result__kind">' + escapeHtml(kindLabel) + '</p>';
        if (name) cards += '<h2 class="vx-result__name">' + escapeHtml(name) + '</h2>';
        if (isAppraisal) {
          var displayVal = String(result).indexOf('$') !== -1 ? String(result) : '$' + result;
          cards += verdictHTML({ value: displayVal, meta: submittedAt ? 'Appraised by SWAU on ' + submittedAt : 'Appraised by SWAU', icon: 'check' });
        } else {
          cards += verdictHTML({
            value: verdict,
            meta: result === 'pending' ? 'Our team is still reviewing this item'
              : submittedAt ? 'SWAU opinion, rendered ' + submittedAt : 'SWAU opinion',
            icon: { pass: 'check', fail: 'cross', warn: 'alert' }[kind] || 'clock'
          });
        }
        cards += factsHTML([
          { label: 'Genre', value: v.autographGenre },
          funkoAutograph ? { label: 'Autograph', value: funkoAutograph } : null,
          funkoIssues.length ? { label: 'Noted', value: funkoIssues.join(', '), wide: true } : null,
          v.response && v.response.notes ? { label: 'Notes', value: v.response.notes, wide: true } : null
        ]);
        cards += '</div></section>';
      }

      var tone = kinds.indexOf('fail') !== -1 ? 'rose'
        : kinds.indexOf('warn') !== -1 ? 'amber'
        : kinds.length && kinds.every(function (k) { return k === 'pass'; }) ? 'emerald'
        : 'slate';
      var count = verifications.length;
      var tally = [];
      if (count > 1) {
        verdicts.forEach(function (text) {
          var row = tally.filter(function (t) { return t.text === text; })[0];
          if (row) row.n++;
          else tally.push({ text: text, n: 1 });
        });
      }

      var html = '<article class="vx vx--order is-revealing">';
      html += '<header class="vx-hero__head">';
      html += '<div class="vx-badges vx-rise" style="--d:150ms">' + badgesHTML([{ text: 'Online verification', kind: 'plain' }]) + '</div>';
      html += '<h1 class="vx-title vx-rise" style="--d:230ms" tabindex="-1">Order #' + escapeHtml(orderNumber) + '</h1>';
      html += '<p class="vx-sub vx-rise" style="--d:300ms">' + count + (count === 1 ? ' item' : ' items') + ' reviewed by SWAU';
      if (tally.length > 1) {
        html += '<span class="vx-sub__line">' + tally.map(function (t) { return t.n + ' ' + escapeHtml(t.text.toLowerCase()); }).join(' · ') + '</span>';
      }
      html += '</p>';
      html += '</header>';
      html += '<div class="vx-results">' + cards + '</div>';
      html += closingHTML();
      html += '</article>';

      return {
        html: html,
        tone: { tone: tone, level: tone === 'emerald' ? 1 : 0 },
        title: 'Order #' + orderNumber + ' results | SWAU',
        fillWide: false
      };
    }

    function lookupVerificationResults(orderNumber, fromCert, upstreamFailed) {
      function miss() {
        if (fromCert) showError(upstreamFailed ? 'unavailable' : 'not_found', orderNumber);
        else showError('order_pending', orderNumber);
      }
      $.ajax({
        url: API_BASE_URL + '/verification-results/lookup/' + encodeURIComponent(orderNumber),
        type: 'GET',
        success: function(response) {
          if (response && response.length) renderSuccess(buildVerificationResultsHTML(response, orderNumber));
          else miss();
        },
        error: function(xhr) {
          if (xhr.status === 404) miss();
          else showError('unavailable', orderNumber);
        }
      });
    }

    // ── Errors ────────────────────────────────────────────────────────────────

    var ERRORS = {
      not_found: {
        tone: 'rose',
        icon: 'alert',
        title: "This number isn't in the SWAU registry",
        text: 'Check it against the hologram or slab label and try again. If you scanned a SWAU QR code and still see this, contact us before you buy.'
      },
      order_pending: {
        tone: 'amber',
        icon: 'clock',
        title: 'No finished results for this order yet',
        text: 'Online verification results show up here once our team has reviewed your photos. We also email you when they are ready.'
      },
      unavailable: {
        tone: 'slate',
        icon: 'cloud',
        title: "We couldn't reach the SWAU registry",
        text: 'This is a problem on our end, not with your item. Check your connection and try again in a moment.'
      }
    };

    function showError(kind, value) {
      if (lookupAbandoned()) return;
      var e = ERRORS[kind] || ERRORS.not_found;
      var label = value ? (kind === 'order_pending' ? 'Order #' + value : '#' + value) : '';
      var retry = kind === 'unavailable';
      var html = '<div class="vx vx--empty is-revealing"><div class="vx-empty">';
      html += '<div class="vx-empty__icon vx-rise">' + ICONS[e.icon] + '</div>';
      if (label) html += '<p class="vx-empty__cert vx-rise" style="--d:80ms">' + escapeHtml(label) + '</p>';
      html += '<h1 class="vx-empty__title vx-rise" style="--d:140ms" tabindex="-1">' + escapeHtml(e.title) + '</h1>';
      html += '<p class="vx-empty__text vx-rise" style="--d:200ms">' + escapeHtml(e.text) + '</p>';
      html += '<div class="vx-empty__actions vx-rise" style="--d:260ms">';
      if (retry) html += '<button type="button" class="vx-btn vx-btn--primary" data-vx-retry>Try again</button>';
      html += '<button type="button" class="verify-another-item-btn vx-btn ' + (retry ? 'vx-btn--glass' : 'vx-btn--primary') + '">'
           + (kind === 'not_found' ? 'Try another number' : 'Verify another item') + '</button>';
      html += '<a class="vx-btn vx-btn--glass" href="/pages/contact">Contact SWAU</a>';
      html += '</div></div></div>';

      $('.swau-authentication-error--container').html(html);
      pendingTone = { tone: e.tone, level: 0 };
      pendingTitle = DEFAULT_TITLE;
      showResult('error');
    }

    function showInlineError(message) {
      $('#swau-authentication-form .error').text(message).show();
      $('#hologramNumber').trigger('focus');
    }

    // A lookup that lands after "Verify another item" was pressed is dropped.
    function lookupAbandoned() {
      return !document.body.classList.contains('swau-verify-has-result');
    }

    function renderSuccess(result) {
      if (lookupAbandoned()) return;
      var $container = $('.swau-authentication-success--container');
      $container.removeClass('card-report-mode verification-results-mode record-mode').html(result.html);
      pendingTone = result.tone;
      pendingTitle = result.title;
      hydrateStages($container[0], result.fillWide);
      showResult('success');
    }

    function authenticate() {
      var rawInput = String($('#hologramNumber').val() || '').trim();

      // If starts with #, treat as order number lookup
      if (rawInput.charAt(0) === '#') {
        var orderNum = rawInput.substring(1).trim();
        if (!orderNum) {
          showForm();
          showInlineError('Add your order number after the #.');
          return;
        }
        lookupVerificationResults(orderNum, false, false);
        return;
      }

      var hologramNumber = rawInput.replace(/\s+/g, '').toUpperCase();
      if (!hologramNumber) {
        showForm();
        showInlineError('Enter the number from your hologram or slab label.');
        return;
      }

      if (hologramNumber.substring(0, 2) === 'CS') { // Card Slab - show full grading report
        $.ajax({
          url: API_BASE_URL + '/card/lookup/' + encodeURIComponent(hologramNumber),
          type: 'GET',
          success: function(response) {
            if (response && response.length) {
              renderSuccess(buildCardGradingReport(response[0]));
              initCardZoom();
            } else {
              showError('not_found', hologramNumber);
            }
          },
          error: function(xhr) {
            showError(xhr.status === 404 ? 'not_found' : 'unavailable', hologramNumber);
          }
        });
      } else if (hologramNumber.substring(0, 2) === 'FS' || hologramNumber.charAt(0) === 'W') { // Funko Slab
        $.ajax({
          url: API_BASE_URL + '/funko/lookup/' + encodeURIComponent(hologramNumber),
          type: 'GET',
          success: function(response) {
            if (response && response.length) {
              renderSuccess(buildFunkoGradingReport(response[0], response));
            } else {
              showError('not_found', hologramNumber);
            }
          },
          error: function(xhr) {
            showError(xhr.status === 404 ? 'not_found' : 'unavailable', hologramNumber);
          }
        });
      } else {
        $.ajax({
          url: API_BASE_URL + '/hologram/lookup/' + encodeURIComponent(hologramNumber),
          type: 'GET',
          success: function(response) {
            if (response && response.length) {
              renderSuccess(buildHologramRecordHTML(response));
            } else {
              // Hologram not found — try verification results lookup as fallback
              lookupVerificationResults(hologramNumber, true, false);
            }
          },
          error: function(xhr) {
            // Typed order numbers land here too, so a miss still checks verification results.
            lookupVerificationResults(hologramNumber, true, xhr.status !== 404);
          }
        });
      }
    }

    /**
     * Convert 1000-point score to SWAU grade (must match backend convertScoreToGrade)
     */
    function scoreToGrade(score) {
      if (!score || isNaN(score)) return '0';
      var s = Number(score);
      if (s <= 10) return s.toString();
      if (s >= 980) return '10';
      if (s >= 950) return '9.5';
      if (s >= 900) return '9';
      if (s >= 850) return '8.5';
      if (s >= 800) return '8';
      if (s >= 750) return '7.5';
      if (s >= 700) return '7';
      if (s >= 650) return '6.5';
      if (s >= 600) return '6';
      if (s >= 500) return '5';
      if (s >= 400) return '4';
      if (s >= 300) return '3';
      if (s >= 200) return '2';
      if (s >= 150) return '1.5';
      if (s >= 100) return '1';
      return '0';
    }

    /**
     * Get SWAU grade label from numeric grade — must match physical label getGradeString()
     */
    function gradeLabelFromGrade(grade) {
      if (grade != null && String(grade).toUpperCase() === 'A') return 'AUTHENTIC';
      if (grade != null && String(grade).toUpperCase() === 'WS') return 'WINDOW SWAP';
      if (grade != null && String(grade).toUpperCase() === 'C') return 'CUSTOM';
      if (grade != null && String(grade).toUpperCase() === 'S') return 'SKETCH';
      var g = parseFloat(grade);
      if (isNaN(g)) return '';
      var wholeGrade = (g % 1 === 0);
      var floor = Math.floor(g);
      var label = '';
      if (floor === 0) label = 'AUTHENTIC';
      else if (floor === 1) label = 'INCOMPLETE';
      else if (floor === 2) label = 'DISTRESSED';
      else if (floor === 3) label = 'POOR';
      else if (floor === 4) label = 'FAIR';
      else if (floor === 5) label = 'GOOD';
      else if (floor === 6) label = 'VERY GOOD';
      else if (floor === 7) label = 'EXCELLENT';
      else if (floor === 8) label = 'NEAR MINT';
      else if (floor === 9) label = 'MINT';
      else if (floor >= 10) label = 'GEM MINT';
      if (!wholeGrade && label) label += '+';
      return label;
    }

    /**
     * Download a slab photo from URL
     */
    function downloadSlabPhoto(url, filename) {
      try {
        // Extract filename from URL if not provided
        if (!filename) filename = fileNameFor(url);

        // Create temporary anchor element
        var link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.target = '_blank';
        link.rel = 'noopener';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (err) {
        // Fallback: open in new tab
        window.open(url, '_blank');
      }
    }

    // Make downloadSlabPhoto globally accessible for onclick handlers
    window.downloadSlabPhoto = downloadSlabPhoto;

    var cardZoomState = {};

    function getCardZoomState(imgId) {
      if (!cardZoomState[imgId]) cardZoomState[imgId] = { scale: 1, tx: 0, ty: 0 };
      return cardZoomState[imgId];
    }

    function applyCardTransform(imgId) {
      var img = document.getElementById(imgId);
      if (!img) return;
      var s = getCardZoomState(imgId);
      img.style.transform = 'translate(' + s.tx + 'px,' + s.ty + 'px) scale(' + s.scale + ')';
      var display = document.getElementById(imgId + 'ZoomPct');
      if (display) display.textContent = Math.round(s.scale * 100) + '%';
      var container = document.getElementById(imgId + 'Scroll');
      if (container) container.classList.toggle('is-zoomed', s.scale > 1);
    }

    window.cardZoom = function(imgId, delta) {
      var s = getCardZoomState(imgId);
      var img = document.getElementById(imgId);
      var full = img && img.getAttribute('data-full');
      if (delta > 0 && full && img.getAttribute('src') !== full) img.src = full;
      var factor = delta > 0 ? 1.25 : (1 / 1.25);
      var newScale = Math.min(6, Math.max(1, s.scale * factor));
      // Snap back to 1× when close so it's easy to return to normal
      if (newScale < 1.1) { newScale = 1; s.tx = 0; s.ty = 0; }
      s.scale = newScale;
      applyCardTransform(imgId);
    };

    // Scans stay out of the way of page scrolling until someone zooms in.
    function initCardZoom() {
      ['cardScanFront', 'cardScanBack'].forEach(function(imgId) {
        var container = document.getElementById(imgId + 'Scroll');
        if (!container) return;

        cardZoomState[imgId] = { scale: 1, tx: 0, ty: 0 };
        var s = cardZoomState[imgId];
        var drag = { active: false, startX: 0, startY: 0, startTx: 0, startTy: 0 };

        container.addEventListener('wheel', function(e) {
          if (!e.ctrlKey && s.scale === 1) return;
          e.preventDefault();
          window.cardZoom(imgId, e.deltaY < 0 ? 1 : -1);
        }, { passive: false });

        container.addEventListener('mousedown', function(e) {
          if (s.scale <= 1) return;
          drag.active = true;
          drag.startX = e.clientX; drag.startY = e.clientY;
          drag.startTx = s.tx;    drag.startTy = s.ty;
          container.style.cursor = 'grabbing';
          e.preventDefault();
        });
        window.addEventListener('mousemove', function(e) {
          if (!drag.active) return;
          s.tx = drag.startTx + (e.clientX - drag.startX);
          s.ty = drag.startTy + (e.clientY - drag.startY);
          applyCardTransform(imgId);
        });
        window.addEventListener('mouseup', function() {
          if (!drag.active) return;
          drag.active = false;
          container.style.cursor = '';
        });

        container.addEventListener('touchstart', function(e) {
          if (s.scale <= 1 || e.touches.length !== 1) return;
          drag.active = true;
          drag.startX = e.touches[0].clientX; drag.startY = e.touches[0].clientY;
          drag.startTx = s.tx;                drag.startTy = s.ty;
        }, { passive: true });
        container.addEventListener('touchmove', function(e) {
          if (!drag.active || e.touches.length !== 1) return;
          e.preventDefault();
          s.tx = drag.startTx + (e.touches[0].clientX - drag.startX);
          s.ty = drag.startTy + (e.touches[0].clientY - drag.startY);
          applyCardTransform(imgId);
        }, { passive: false });
        container.addEventListener('touchend', function() { drag.active = false; }, { passive: true });
      });
    }

    window.centeringToggle = function(id, side) {
      var frontEl  = document.getElementById(id + '-front');
      var backEl   = document.getElementById(id + '-back');
      var btnFront = document.getElementById(id + '-btn-front');
      var btnBack  = document.getElementById(id + '-btn-back');
      if (!frontEl || !backEl) return;
      var showFront = side === 'front';
      frontEl.style.display = showFront ? '' : 'none';
      backEl.style.display  = showFront ? 'none' : '';
      if (btnFront) btnFront.classList.toggle('is-active', showFront);
      if (btnBack)  btnBack.classList.toggle('is-active', !showFront);
    };

    /**
     * Build a centering diagram SVG for one side of the card.
     * @param {string|null} lr  - Left/Right ratio string e.g. "48/52"
     * @param {string|null} tb  - Top/Bottom ratio string e.g. "51/49"
     * @param {string}      sideLabel - "FRONT" or "BACK"
     */
    function buildCenteringDiagram(lr, tb, sideLabel) {
      var leftPct = 50, rightPct = 50, topPct = 50, botPct = 50;
      var hasLR = false, hasTB = false;
      if (lr) {
        var lrp = lr.split('/');
        if (lrp.length === 2 && !isNaN(parseFloat(lrp[0]))) {
          leftPct  = parseFloat(lrp[0]);
          rightPct = parseFloat(lrp[1]);
          hasLR = true;
        }
      }
      if (tb) {
        var tbp = tb.split('/');
        if (tbp.length === 2 && !isNaN(parseFloat(tbp[0]))) {
          topPct = parseFloat(tbp[0]);
          botPct = parseFloat(tbp[1]);
          hasTB = true;
        }
      }
      if (!hasLR && !hasTB) return '';

      function fmtPct(v) {
        return (v % 1 === 0) ? String(Math.round(v)) : v.toFixed(2);
      }

      // SVG layout — standard card ratio 5:7 (2.5" x 3.5"); minimal bottom padding to reduce gap under diagram
      var W = 380;
      var padLR = 54, padTB = 48, padBottom = 22;
      var cardW = W - padLR * 2;
      var cardH = Math.round(cardW * 7 / 5);
      var H = cardH + padTB + padBottom;
      var cardX = padLR, cardY = padTB;
      var cx = cardX + cardW / 2;
      var cy = cardY + cardH / 2;

      // Total border budget split proportionally by the centering percentages
      var hBudget = Math.round(cardW * 0.26);
      var vBudget = Math.round(cardH * 0.22);
      var leftB  = hasLR ? hBudget * leftPct  / 100 : hBudget / 2;
      var rightB = hasLR ? hBudget * rightPct / 100 : hBudget / 2;
      var topB   = hasTB ? vBudget * topPct   / 100 : vBudget / 2;
      var botB   = hasTB ? vBudget * botPct   / 100 : vBudget / 2;
      var innerX = cardX + leftB;
      var innerY = cardY + topB;
      var innerW = cardW - leftB - rightB;
      var innerH = cardH - topB - botB;

      var bk = 14, bw = 2.5;
      var dash = 'stroke-dasharray="5,4"';
      var dl = ' stroke="rgba(255,255,255,0.28)" stroke-width="0.8" ' + dash + '/>';
      var tAttr = 'font-size="9" font-weight="700" fill="#ffffff" text-anchor="middle" dominant-baseline="middle"';

      var out = [];
      out.push('<svg viewBox="0 0 ' + W + ' ' + H + '" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="width:100%;max-width:380px;display:block;margin:0 auto;font-family:inherit;">');

      // Outer card — border region shaded
      out.push('<rect x="' + cardX + '" y="' + cardY + '" width="' + cardW + '" height="' + cardH + '" fill="rgba(255,255,255,0.12)"/>');
      // Inner artwork area
      out.push('<rect x="' + innerX + '" y="' + innerY + '" width="' + innerW + '" height="' + innerH + '" fill="#0b0f1f"/>');
      // Outer card stroke
      out.push('<rect x="' + cardX + '" y="' + cardY + '" width="' + cardW + '" height="' + cardH + '" fill="none" stroke="rgba(255,255,255,0.85)" stroke-width="1.5"/>');

      // Corner brackets
      function mkBracket(ax, ay, dx, dy) {
        return '<polyline points="' + (ax+dx*bk) + ',' + ay + ' ' + ax + ',' + ay + ' ' + ax + ',' + (ay+dy*bk) + '" fill="none" stroke="#ffffff" stroke-width="' + bw + '" stroke-linecap="square"/>';
      }
      out.push(mkBracket(cardX,       cardY,        1,  1));
      out.push(mkBracket(cardX+cardW, cardY,       -1,  1));
      out.push(mkBracket(cardX,       cardY+cardH,  1, -1));
      out.push(mkBracket(cardX+cardW, cardY+cardH, -1, -1));

      // Inner artwork boundary (dashed)
      out.push('<rect x="' + innerX + '" y="' + innerY + '" width="' + innerW + '" height="' + innerH + '" fill="none" stroke="rgba(255,255,255,0.5)" stroke-width="1" ' + dash + '/>');

      // Dashed diagonals — outer corners to card center
      out.push('<line x1="' + cardX         + '" y1="' + cardY         + '" x2="' + cx + '" y2="' + cy + '"' + dl);
      out.push('<line x1="' + (cardX+cardW) + '" y1="' + cardY         + '" x2="' + cx + '" y2="' + cy + '"' + dl);
      out.push('<line x1="' + cardX         + '" y1="' + (cardY+cardH) + '" x2="' + cx + '" y2="' + cy + '"' + dl);
      out.push('<line x1="' + (cardX+cardW) + '" y1="' + (cardY+cardH) + '" x2="' + cx + '" y2="' + cy + '"' + dl);
      // Dashed crosshairs
      out.push('<line x1="' + cardX + '" y1="' + cy + '" x2="' + (cardX+cardW) + '" y2="' + cy + '"' + dl);
      out.push('<line x1="' + cx + '" y1="' + cardY + '" x2="' + cx + '" y2="' + (cardY+cardH) + '"' + dl);

      // Center logo badge (smaller, more padding)
      var lbW = 48, lbH = 20;
      var lbPadX = 6, lbPadY = 5;
      var lbX = Math.round(cx - lbW / 2), lbY = Math.round(cy - lbH / 2);
      out.push('<rect x="' + lbX + '" y="' + lbY + '" width="' + lbW + '" height="' + lbH + '" fill="#1a1a2e" stroke="rgba(255,255,255,0.2)" rx="4"/>');
      out.push('<image href="https://cdn.shopify.com/s/files/1/0535/6434/2470/files/SWAU_1_White.png?v=1752539840" x="' + (lbX+lbPadX) + '" y="' + (lbY+lbPadY) + '" width="' + (lbW-lbPadX*2) + '" height="' + (lbH-lbPadY*2) + '" preserveAspectRatio="xMidYMid meet"/>');

      // Labels inside the border regions (rotated 90° for left/right)
      if (hasTB) {
        out.push('<text x="' + cx + '" y="' + (cardY + topB / 2) + '" ' + tAttr + '>C ' + fmtPct(topPct) + '</text>');
        out.push('<text x="' + cx + '" y="' + (cardY + cardH - botB / 2) + '" ' + tAttr + '>C ' + fmtPct(botPct) + '</text>');
      }
      if (hasLR) {
        var lxC = cardX + leftB / 2;
        out.push('<text x="' + lxC + '" y="' + cy + '" ' + tAttr + ' transform="rotate(-90 ' + lxC + ' ' + cy + ')">C ' + fmtPct(leftPct) + '</text>');
        var rxC = cardX + cardW - rightB / 2;
        out.push('<text x="' + rxC + '" y="' + cy + '" ' + tAttr + ' transform="rotate(-90 ' + rxC + ' ' + cy + ')">C ' + fmtPct(rightPct) + '</text>');
      }

      // Side label
      out.push('<text x="' + (W/2) + '" y="' + (H-5) + '" text-anchor="middle" dominant-baseline="auto" fill="rgba(255,255,255,0.4)" font-size="8" font-weight="700" letter-spacing="2">' + sideLabel + '</text>');

      out.push('</svg>');
      return out.join('');
    }

    // ── Funko POP report ──────────────────────────────────────────────────────

    function buildFunkoGradingReport(obj, response) {
      var certNumber  = obj.certificationNumber || '';
      var funkoName   = obj.funkoName || 'Funko POP';
      var exclusive   = obj.funkoExclusive || '';
      var rarity      = obj.funkoRarity ? 'LE ' + obj.funkoRarity : '';
      var certDate    = obj.date || '';
      var overallGrade = String(obj.overallGrade || '').trim();
      var swauPop        = obj.swauPop        != null ? obj.swauPop        : null;
      var swauPopHigher  = obj.swauPopHigher  != null ? obj.swauPopHigher  : null;
      var swauTotal      = obj.swauTotal      != null ? obj.swauTotal      : (swauPop != null && swauPopHigher != null ? swauPop + swauPopHigher : null);

      // Collect unique autographs across all response records
      var autographs = [];
      for (var i = 0; i < response.length; i++) {
        var r = response[i];
        if (r.autographName) {
          autographs.push({ name: r.autographName, grade: r.autographGrade != null ? String(r.autographGrade).trim() : '' });
        }
      }

      var grades = [];
      if (overallGrade) {
        var item = makeGrade('item', 'Funko', overallGrade);
        var label = obj.grading && obj.grading.grade_label;
        if (label) item.name = titleCase(label);
        grades.push(item);
      }
      if (autographs.length === 1 && autographs[0].grade) {
        grades.push(makeGrade('autograph', 'Autograph', autographs[0].grade));
      }
      var headline = headlineGrade(grades);

      var photos = uniquePhotos((Array.isArray(obj.slabPhotos) ? obj.slabPhotos : []).concat(response.map(function (rec) { return rec.photo; })));

      var details = '';
      if (autographs.length > 1) {
        details += '<section class="vx-section"><h2 class="vx-section__title">Signatures</h2><div class="vx-sigs">';
        autographs.forEach(function (ag, n) {
          details += '<div class="vx-sig"><div class="vx-sig__head">';
          details += '<span class="vx-sig__num">' + (n + 1) + '</span>';
          details += '<p class="vx-sig__name">' + escapeHtml(ag.name) + '</p>';
          if (ag.grade) details += '<span class="vx-sig__grade">Auto ' + escapeHtml(ag.grade) + '</span>';
          details += '</div></div>';
        });
        details += '</div></section>';
      }
      details += populationHTML({
        pop: swauPop,
        higher: swauPopHigher,
        total: swauTotal,
        gradeName: grades[0] ? grades[0].name : ''
      });

      var summary = gradeSummary(grades);
      return {
        html: resultHTML({
          kind: 'funko',
          gradeSummary: summary,
          cert: certNumber,
          title: funkoName,
          subLines: [
            [exclusive, rarity].filter(Boolean).map(escapeHtml).join(' · '),
            autographs.length === 1 ? 'Signed by <strong>' + escapeHtml(autographs[0].name) + '</strong>'
              : autographs.length > 1 ? escapeHtml(autographs.length + ' signatures') : ''
          ],
          badges: [{ text: 'Verified · SWAU graded', icon: 'check' }],
          grades: grades,
          photos: photos,
          facts: [
            { label: 'Cert', value: certNumber, mono: true },
            { label: 'Certified', value: certDate },
            { label: 'SWAU Pop', value: popFact(swauPop, swauTotal) }
          ],
          details: details,
          shareTitle: funkoName + (summary ? ' · ' + summary : ''),
          shareText: funkoName + (summary ? ', ' + summary : '') + '. Graded by SWAU, cert #' + certNumber + '.'
        }),
        tone: toneForGrades(grades),
        title: funkoName + (headline ? ' · ' + summary : '') + ' | SWAU',
        fillWide: true
      };
    }

    // ── Trading card report ───────────────────────────────────────────────────

    function buildCardGradingReport(card) {
      var grading = card.grading || card.reviewedGrading || {};
      var subgrades = grading.subgrades || {};
      var defects = grading.defects || [];
      var scans = card.scans || grading.scans || {};
      var overallScore = grading.overall_score || 0;
      var overallGrade = String(card.overallGrade || scoreToGrade(overallScore));
      var numericItem = isNumericGrade(overallGrade);
      var gradeLabel = grading.grade_label || gradeLabelFromGrade(overallGrade);

      // Cap context: structured "why this score" info emitted by the rubric.
      // When present, subgrade cards show a small note like "Limited by minor scratch".
      var capContext = grading.cap_context || null;
      var subgradeCapReasons = (capContext && capContext.subgrade_caps) || {};
      // Inline grade-band ranges (must mirror SWAU_GRADING_RUBRIC.GRADE_BANDS).
      // Keeping this list local because verifyHologram runs in Shopify's theme
      // context with no shared script loader. Update both places together.
      var GRADE_BANDS = [
        { min: 980, numeric: '10',  label: 'Gem Mint' },
        { min: 950, numeric: '9.5', label: 'Mint+' },
        { min: 900, numeric: '9',   label: 'Mint' },
        { min: 850, numeric: '8.5', label: 'Near Mint+' },
        { min: 800, numeric: '8',   label: 'Near Mint' },
        { min: 750, numeric: '7.5', label: 'Excellent+' },
        { min: 700, numeric: '7',   label: 'Excellent' },
        { min: 650, numeric: '6.5', label: 'Very Good+' },
        { min: 600, numeric: '6',   label: 'Very Good' },
        { min: 500, numeric: '5',   label: 'Good' },
        { min: 400, numeric: '4',   label: 'Fair' },
        { min: 300, numeric: '3',   label: 'Poor' }
      ];
      function bandForScore(s) {
        var n = Number(s);
        if (!isFinite(n)) return null;
        for (var i = 0; i < GRADE_BANDS.length; i++) {
          if (n >= GRADE_BANDS[i].min) {
            var maxV = i === 0 ? 1000 : GRADE_BANDS[i - 1].min - 1;
            return { min: GRADE_BANDS[i].min, max: maxV, numeric: GRADE_BANDS[i].numeric, label: GRADE_BANDS[i].label };
          }
        }
        return null;
      }
      function bandTitle(b) {
        return 'Grade ' + b.numeric + ' = scores ' + b.min + '\u2013' + b.max + ' on the 1000\u2011point scale';
      }
      // Pretty subgrade cap reason like "Limited by minor scratch".
      function capReasonText(reason) {
        if (!reason) return '';
        if (reason.cumulative) return 'Limited by ' + reason.count + ' scratches';
        if (reason.source === 'centering') return 'Limited by front centering';
        var sev = reason.severity ? reason.severity + ' ' : '';
        var t = (reason.type || '').toLowerCase();
        return t ? 'Limited by ' + sev + t : '';
      }

      // Card identification — label fields (Step 3) take priority over AI grading data
      var cardId = grading.card_identification || {};
      var baseCardName = card.cardName || card.playerCharacter || cardId.player_character || 'Unknown card';
      var cardRarity = String(card.cardRarity || card.variant || cardId.variant || '').trim();
      var cardYear = card.yearOfIssue || card.year || cardId.year || '';
      var cardSet = card.setName || card.set || cardId.set || '';
      var manufacturer = card.manufacturer || cardId.manufacturer || '';
      var cardNumber = card.cardNumber || cardId.card_number || '';
      var autographName = card.autographName || cardId.autograph_name || '';
      var autographGrade = card.autographGrade != null ? String(card.autographGrade).trim() : '';
      var artBy = String(card.artBy || '').trim();
      var certNumber = card.certificationNumber || '';
      var certDate = card.date || (card.createdAt ? new Date(card.createdAt).toLocaleDateString('en-US') : '');

      var maker = manufacturer && String(cardSet).toLowerCase().indexOf(String(manufacturer).toLowerCase()) === -1 ? manufacturer : '';
      var setLine = [cardYear, maker, cardSet].filter(Boolean).join(' ');
      var idLine = [setLine, cardNumber ? '#' + cardNumber : ''].filter(Boolean).join(' · ');

      // Grades: the card itself, plus the autograph grade printed on the slab label.
      var grades = [];
      var itemGrade = makeGrade('item', 'Card', overallGrade);
      if (gradeLabel) itemGrade.name = titleCase(gradeLabel);
      grades.push(itemGrade);
      if (autographGrade) grades.push(makeGrade('autograph', 'Autograph', autographGrade));
      var anyNumeric = grades.some(function (g) { return g.numeric; });

      // Subgrade scores
      var centeringScore = subgrades.centering ? subgrades.centering.overall : null;
      var cornersScore = card.cornersGrade || (subgrades.corners ? subgrades.corners.overall : null) || (subgrades.corners && subgrades.corners.front ? subgrades.corners.front.score : null);
      var edgesScore   = card.edgesGrade   || (subgrades.edges   ? subgrades.edges.overall   : null) || (subgrades.edges   && subgrades.edges.front   ? subgrades.edges.front.score   : null);
      var surfaceScore = card.surfaceGrade || (subgrades.surface ? subgrades.surface.overall : null);

      var subgradesHTML = '';
      if (numericItem && (centeringScore != null || cornersScore != null || edgesScore != null || surfaceScore != null)) {
        var tiles = [
          ['Centering', centeringScore, 'centering'],
          ['Corners', cornersScore, 'corners'],
          ['Edges', edgesScore, 'edges'],
          ['Surface', surfaceScore, 'surface']
        ];
        var capNotes = [];
        subgradesHTML = '<div class="vx-subgrades-wrap vx-rise" style="--d:480ms"><div class="vx-subgrades">';
        tiles.forEach(function (t) {
          var score = t[1];
          var band = score != null ? bandForScore(score) : null;
          subgradesHTML += '<div class="vx-subgrade">';
          subgradesHTML += '<p class="vx-subgrade__label">' + t[0] + '</p>';
          subgradesHTML += '<p class="vx-subgrade__value">' + (score != null ? scoreToGrade(score) : '—') + '</p>';
          if (score != null) {
            subgradesHTML += '<p class="vx-subgrade__score"' + (band ? ' title="' + escapeHtml(bandTitle(band)) + '"' : '') + '>'
                          + escapeHtml(score) + ' / 1000</p>';
          }
          var cap = capReasonText(subgradeCapReasons[t[2]]);
          if (cap) {
            var note = capNotes.filter(function (n) { return n.cap === cap; })[0];
            if (note) note.names.push(t[0].toLowerCase());
            else capNotes.push({ cap: cap, names: [t[0]] });
          }
          subgradesHTML += '</div>';
        });
        subgradesHTML += '</div>';
        // Caps sit under the grid so every tile keeps the same height.
        capNotes.forEach(function (n) {
          subgradesHTML += '<p class="vx-subgrades__note">' + escapeHtml(joinNames(n.names) + ' ' + n.cap.charAt(0).toLowerCase() + n.cap.slice(1)) + '</p>';
        });
        subgradesHTML += '</div>';
      }

      // Centering measurements
      var centeringFrontLR = null, centeringFrontTB = null, centeringBackLR = null, centeringBackTB = null;

      function computeDisplayRatio(a, b) {
        if (!a || !b || a <= 0 || b <= 0) return null;
        var total = a + b;
        var pctA = Math.round(a / total * 100);
        return pctA + '/' + (100 - pctA);
      }

      var frontBordersObj = subgrades.centering && subgrades.centering.front ? subgrades.centering.front.borders : null;
      var backBordersObj  = subgrades.centering && subgrades.centering.back  ? subgrades.centering.back.borders  : null;

      if (frontBordersObj) {
        centeringFrontLR = computeDisplayRatio(frontBordersObj.left, frontBordersObj.right);
        centeringFrontTB = computeDisplayRatio(frontBordersObj.top, frontBordersObj.bottom);
      }
      if (backBordersObj) {
        centeringBackLR = computeDisplayRatio(backBordersObj.left, backBordersObj.right);
        centeringBackTB = computeDisplayRatio(backBordersObj.top, backBordersObj.bottom);
      }

      if (!centeringFrontLR && subgrades.centering && subgrades.centering.front) centeringFrontLR = subgrades.centering.front.left_right || null;
      if (!centeringFrontTB && subgrades.centering && subgrades.centering.front) centeringFrontTB = subgrades.centering.front.top_bottom || null;
      if (!centeringBackLR && subgrades.centering && subgrades.centering.back) centeringBackLR = subgrades.centering.back.left_right || null;
      if (!centeringBackTB && subgrades.centering && subgrades.centering.back) centeringBackTB = subgrades.centering.back.top_bottom || null;

      var frontScanUrl = scans.frontCropped || scans.front;
      var backScanUrl  = scans.backCropped  || scans.back;

      var details = '';

      // ── Population / rank ──
      var swauPop      = card.swauPop      != null ? card.swauPop      : null;
      var swauPopHigher= card.swauPopHigher != null ? card.swauPopHigher : null;
      var swauTotal    = card.swauTotal    != null ? card.swauTotal    : (swauPop != null && swauPopHigher != null ? swauPop + swauPopHigher : null);
      details += populationHTML({
        pop: swauPop,
        higher: swauPopHigher,
        total: swauTotal,
        mintRank: card.mintRank != null ? card.mintRank : null,
        overallRank: card.overallRank != null ? card.overallRank : null,
        gradeName: itemGrade.name
      });

      // ── Card scans with zoom ──
      if (frontScanUrl || backScanUrl) {
        var scanHTML = function (url, label, imgId) {
          var out = '<div class="card-scan-wrapper">';
          out += '<p class="vx-scan__label">' + label + '</p>';
          // overflow:hidden + flex-center so transform:scale zoom has no layout side-effects and no scrollbars
          out += '<div class="vr-scan__stage" id="' + imgId + 'Scroll">';
          // The thumb is plenty at 100%; the full scan loads on the first zoom-in.
          out += '<img class="card-scan-img" id="' + imgId + '" src="' + escapeHtml(thumbFor(url) || url) + '" data-full="' + escapeHtml(url) + '"'
               + ' alt="Card ' + label.toLowerCase() + ' scan" decoding="async"';
          out += ' style="transform:translate(0px,0px) scale(1);" />';
          out += '</div>';
          out += '<div class="vr-scan__zoom">';
          out += '<button type="button" class="vr-zoom-btn" data-vx-zoom="' + imgId + '" data-dir="-1" aria-label="Zoom out of the ' + label.toLowerCase() + '">&#x2212;</button>';
          out += '<span class="vr-zoom-pct" id="' + imgId + 'ZoomPct">100%</span>';
          out += '<button type="button" class="vr-zoom-btn" data-vx-zoom="' + imgId + '" data-dir="1" aria-label="Zoom into the ' + label.toLowerCase() + '">&#x2B;</button>';
          out += '</div>';
          out += '</div>';
          return out;
        };
        var oneScan = !(frontScanUrl && backScanUrl);
        details += '<section class="vx-section"><h2 class="vx-section__title">Card scans</h2>';
        details += '<div class="vx-scans"' + (oneScan ? ' style="grid-template-columns:minmax(0,20rem);justify-content:center"' : '') + '>';
        if (frontScanUrl) details += scanHTML(frontScanUrl, 'Front', 'cardScanFront');
        if (backScanUrl)  details += scanHTML(backScanUrl,  'Back',  'cardScanBack');
        details += '</div>';
        details += '<p class="vx-section__hint">Tap + to zoom in, then drag to look closer.</p>';
        details += '</section>';
      }

      // ── Centering Detail ──
      // Reviewed cards often carry only the L/R and T/B ratios (no pixel borders); those still get the breakdown.
      var hasFrontCentering = centeringFrontLR || centeringFrontTB;
      var hasBackCentering  = centeringBackLR  || centeringBackTB;
      if (numericItem && (hasFrontCentering || hasBackCentering)) {
        var cDiagId = 'cdiag-' + (certNumber || Date.now());
        var bothSides = hasFrontCentering && hasBackCentering;

        details += '<section class="vx-section centering-detail"><h2 class="vx-section__title">Centering</h2>';

        if (bothSides) {
          details += '<div class="vr-centering-tabs">';
          details += '<button type="button" class="vr-centering-tab is-active" id="' + cDiagId + '-btn-front" onclick="centeringToggle(\'' + cDiagId + '\',\'front\')">FRONT</button>';
          details += '<button type="button" class="vr-centering-tab" id="' + cDiagId + '-btn-back" onclick="centeringToggle(\'' + cDiagId + '\',\'back\')">BACK</button>';
          details += '</div>';
        }

        if (hasFrontCentering) {
          details += '<div id="' + cDiagId + '-front" class="centering-diagram-wrap">';
          details += buildCenteringDiagram(centeringFrontLR, centeringFrontTB, 'FRONT');
          details += '</div>';
        }
        // Back panel (hidden initially when both sides exist)
        if (hasBackCentering) {
          details += '<div id="' + cDiagId + '-back" class="centering-diagram-wrap"' + (bothSides ? ' style="display:none;"' : '') + '>';
          details += buildCenteringDiagram(centeringBackLR, centeringBackTB, 'BACK');
          details += '</div>';
        }

        // ── Measurements Table ──
        (function() {
          function pxCell(bordersObj, key, total) {
            if (!bordersObj || !bordersObj[key] || bordersObj[key] <= 0) return '—';
            var pct = total > 0 ? Math.round(bordersObj[key] / total * 100) : null;
            return pct !== null ? pct + '%' : '—';
          }

          var fLRtotal = frontBordersObj ? (frontBordersObj.left || 0) + (frontBordersObj.right || 0) : 0;
          var fTBtotal = frontBordersObj ? (frontBordersObj.top || 0) + (frontBordersObj.bottom || 0) : 0;
          var bLRtotal = backBordersObj  ? (backBordersObj.left  || 0) + (backBordersObj.right  || 0) : 0;
          var bTBtotal = backBordersObj  ? (backBordersObj.top   || 0) + (backBordersObj.bottom || 0) : 0;

          var showPixels = !!(frontBordersObj || backBordersObj);

          // Div grid, not <table> — Prestige zeros first-column padding on tables.
          var colCount = (hasFrontCentering ? 1 : 0) + (hasBackCentering ? 1 : 0);
          details += '<div class="vr-measure" style="--vr-measure-cols:' + colCount + ';">';
          details += '<div class="vr-measure__head">';
          details += '<div class="vr-measure__head-label">Border</div>';
          if (hasFrontCentering) details += '<div class="vr-measure__head-val">Front</div>';
          if (hasBackCentering)  details += '<div class="vr-measure__head-val">Back</div>';
          details += '</div>';

          function measureRow(label, frontVal, backVal, isRatio) {
            var row = '<div class="vr-measure__row' + (isRatio ? ' vr-measure__row--ratio' : '') + '">';
            row += '<div class="vr-measure__label">' + label + '</div>';
            if (hasFrontCentering) row += '<div class="vr-measure__val">' + frontVal + '</div>';
            if (hasBackCentering)  row += '<div class="vr-measure__val">' + backVal + '</div>';
            row += '</div>';
            return row;
          }

          if (showPixels) {
            details += measureRow(
              'Left',
              frontBordersObj ? pxCell(frontBordersObj, 'left', fLRtotal) : '—',
              backBordersObj ? pxCell(backBordersObj, 'left', bLRtotal) : '—',
              false
            );
            details += measureRow(
              'Right',
              frontBordersObj ? pxCell(frontBordersObj, 'right', fLRtotal) : '—',
              backBordersObj ? pxCell(backBordersObj, 'right', bLRtotal) : '—',
              false
            );
          }
          details += measureRow('L / R Ratio', centeringFrontLR || '—', centeringBackLR || '—', true);
          if (showPixels) {
            details += measureRow(
              'Top',
              frontBordersObj ? pxCell(frontBordersObj, 'top', fTBtotal) : '—',
              backBordersObj ? pxCell(backBordersObj, 'top', bTBtotal) : '—',
              false
            );
            details += measureRow(
              'Bottom',
              frontBordersObj ? pxCell(frontBordersObj, 'bottom', fTBtotal) : '—',
              backBordersObj ? pxCell(backBordersObj, 'bottom', bTBtotal) : '—',
              false
            );
          }
          details += measureRow('T / B Ratio', centeringFrontTB || '—', centeringBackTB || '—', true);

          details += '</div>';
        }());

        details += '</section>';
      }

      // ── Defects (numeric grades only — A / S / C / WS have no defect breakdown) ──
      if (numericItem) {
        details += '<section class="vx-section card-report-defects"><h2 class="vx-section__title">Defect analysis</h2>';
        var hasLocation = function (d) { return d.location && d.location.x != null && d.location.y != null; };
        var frontDefectsWithLoc = defects.filter(function (d) { return (d.side === 'front' || d.side === 'Front') && hasLocation(d); });
        var backDefectsWithLoc = defects.filter(function (d) { return (d.side === 'back' || d.side === 'Back') && hasLocation(d); });

        // Both sides are always shown so a clean back reads as checked, not missing.
        if (frontScanUrl || backScanUrl) {
          var defectCardHTML = function (url, sideLabel, sideDefects) {
            var markerPositions = computeDefectMarkerPositions(sideDefects);
            var out = '<div class="defect-card-side">';
            out += '<div class="defect-card-side-label">' + sideLabel + '</div>';
            out += '<div class="defect-card-img-wrap">';
            out += '<div class="defect-card-img-inner">';
            out += '<img src="' + escapeHtml(thumbFor(url) || url) + '" alt="Card ' + sideLabel.toLowerCase()
                 + (sideDefects.length ? ' with defects marked' : '') + '" decoding="async" />';
            out += '</div>';
            for (var di = 0; di < markerPositions.length; di++) {
              var mp = markerPositions[di];
              var leftPct = (mp.x * 100).toFixed(4) + '%';
              var topPct = (mp.y * 100).toFixed(4) + '%';
              out += '<div class="defect-marker" style="left:' + leftPct + ';top:' + topPct + ';z-index:' + (di + 1) + ';">';
              out += '<span>' + escapeHtml(mp.id) + '</span>';
              out += '</div>';
            }
            out += '</div>';
            out += '</div>';
            return out;
          };
          details += '<div class="defect-card-images">';
          if (frontScanUrl) details += defectCardHTML(frontScanUrl, 'Front', frontDefectsWithLoc);
          if (backScanUrl) details += defectCardHTML(backScanUrl, 'Back', backDefectsWithLoc);
          details += '</div>';
        }

        if (defects.length === 0) {
          var gradeNumForPristine = parseFloat(overallGrade);
          var isPristineGrade = !isNaN(gradeNumForPristine) && gradeNumForPristine >= 10
            && (!overallScore || Number(overallScore) >= 1000);
          if (isPristineGrade) {
            details += '<div class="no-defects-msg">No defects detected. This card is in pristine condition.</div>';
          } else {
            details += '<div class="no-defects-msg">No individual defects were catalogued. Condition details are reflected in the subgrades above.</div>';
          }
        } else {
          for (var i = 0; i < defects.length; i++) {
            var d = defects[i];
            var rowId = d.id != null ? d.id : (i + 1);
            details += '<div class="defect-row">';
            if (hasLocation(d)) {
              details += '<div class="defect-num-badge"><span>' + escapeHtml(rowId) + '</span></div>';
            }
            details += '<div class="defect-info">';
            details += '<div class="defect-type">' + escapeHtml(d.type || 'Unknown') + '</div>';
            if (d.description) {
              details += '<div class="defect-desc">' + escapeHtml(d.description) + '</div>';
            }
            details += '</div>';
            if (d.side) details += '<span class="defect-side">' + escapeHtml(d.side) + '</span>';
            details += '</div>';
          }
        }
        details += '</section>';
      }

      var photos = uniquePhotos(Array.isArray(card.slabPhotos) ? card.slabPhotos : []);
      if (!photos.length) photos = uniquePhotos([frontScanUrl, backScanUrl]);

      var showVariant = cardRarity && !/^autograph(ed)?$/i.test(cardRarity);
      var summary = gradeSummary(grades);
      return {
        html: resultHTML({
          kind: 'card',
          gradeSummary: summary,
          cert: certNumber,
          title: baseCardName,
          subLines: [
            escapeHtml(idLine),
            autographName ? 'Signed by <strong>' + escapeHtml(autographName) + '</strong>' : '',
            artBy ? 'Art by <strong>' + escapeHtml(artBy) + '</strong>' : ''
          ],
          badges: [
            { text: anyNumeric ? 'Verified · SWAU graded' : 'Verified authentic', icon: 'check' },
            card.swauWitnessed ? { text: 'Witnessed', kind: 'witnessed' } : null
          ],
          grades: grades,
          subgradesHTML: subgradesHTML,
          photos: photos,
          facts: [
            { label: 'Cert', value: certNumber, mono: true },
            { label: 'Certified', value: certDate },
            showVariant ? { label: 'Variant', value: cardRarity } : null,
            { label: 'SWAU Pop', value: popFact(swauPop, swauTotal) }
          ],
          details: details,
          shareTitle: baseCardName + ' · ' + summary,
          shareText: baseCardName + ', ' + summary + '. Graded by SWAU, cert #' + certNumber + '.'
        }),
        tone: toneForGrades(grades),
        title: baseCardName + ' · ' + summary + ' | SWAU',
        fillWide: true
      };
    }

    // ── Reveal choreography ───────────────────────────────────────────────────

    function launchConfetti(color) {
      var colors = [color, '#ffffff', '#fbbf24', '#fb7185', '#7dd3fc', '#a78bfa'];
      var wrap = document.createElement('div');
      wrap.className = 'vx-confetti';
      wrap.setAttribute('aria-hidden', 'true');
      var pieces = '';
      for (var i = 0; i < 80; i++) {
        pieces += '<span style="left:' + (Math.random() * 100).toFixed(2) + '%;'
          + 'width:' + (6 + Math.random() * 5).toFixed(1) + 'px;'
          + 'height:' + (9 + Math.random() * 9).toFixed(1) + 'px;'
          + 'background:' + colors[i % colors.length] + ';'
          + '--drift:' + ((Math.random() - 0.5) * 30).toFixed(1) + 'vw;'
          + '--spin:' + ((Math.random() > 0.5 ? 1 : -1) * (360 + Math.random() * 720)).toFixed(0) + 'deg;'
          + '--dur:' + (2.2 + Math.random() * 1.8).toFixed(2) + 's;'
          + '--delay:' + (0.9 + Math.random() * 0.9).toFixed(2) + 's"></span>';
      }
      wrap.innerHTML = pieces;
      document.body.appendChild(wrap);
      setTimeout(function () {
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
      }, 6500);
    }

    function flashPage() {
      if (REDUCED_MOTION) return;
      var page = pageEl();
      var flash = page && page.querySelector('.vx-flash');
      if (!flash) return;
      flash.classList.remove('is-on');
      void flash.offsetWidth;
      flash.classList.add('is-on');
    }

    // A tapped reveal already flashed on the way in; it lands with sound and celebrates from level 2 like Rips.
    function playReveal(tone, fromSeal) {
      var color = TONE_COLORS[tone.tone] || TONE_COLORS.gold;
      if (fromSeal) {
        playLand(tone.level);
        if (tone.level >= 1 && navigator.vibrate) {
          try { navigator.vibrate([[20], [25], [30, 40, 30], [40, 50, 40, 50, 80]][tone.level]); } catch (e) {}
        }
        if (!REDUCED_MOTION && tone.level >= 2) launchConfetti(color);
        return;
      }
      if (REDUCED_MOTION) return;
      flashPage();
      if (tone.level >= 3) launchConfetti(color);
    }

    function sealedEl() {
      return document.querySelector('[data-vx-sealed]');
    }

    function showSealed(raw) {
      var cert = String(raw || '').replace(/\s+/g, '').toUpperCase();
      var noun = cert.indexOf('CS') === 0 ? 'card'
        : (cert.indexOf('FS') === 0 || cert.charAt(0) === 'W') ? 'Funko'
        : 'item';
      revealState = { phase: 'sealed', ready: false, chargeDone: false, noun: noun };
      removeNoFlashStyles();
      setTone('silver', 0);
      setResultMode(true, lookupLabel(raw));
      document.body.classList.add('swau-verify-reveal');
      $('.swau-card, .swau-loading-container, .swau-authentication-success--container, .swau-authentication-error--container').hide();
      $('[data-vx-sealed-eyebrow]').text('Your ' + noun + ' is ready');
      $('[data-vx-reveal]').prop('disabled', false);
      $('[data-vx-reveal-label]').text('Reveal');
      var sealed = sealedEl();
      if (sealed) sealed.classList.remove('is-charging');
      // The tab title stays spoiler-free until the tap.
      document.title = 'Cert #' + cert + ' · SWAU Reveal';
      var sound = document.querySelector('[data-vx-sound]');
      if (sound) {
        sound.hidden = false;
        sound.setAttribute('aria-pressed', soundOn() ? 'true' : 'false');
      }
    }

    function endSealed() {
      document.body.classList.remove('swau-verify-reveal');
      var sealed = sealedEl();
      if (sealed) sealed.classList.remove('is-charging');
      if (revealState) revealState.phase = 'done';
    }

    function startCharge() {
      if (!revealState || revealState.phase !== 'sealed') return;
      unlockAudio();
      revealState.phase = 'charging';
      if (REDUCED_MOTION) {
        revealState.chargeDone = true;
        if (revealState.ready) finishSealed();
        return;
      }
      var sealed = sealedEl();
      if (sealed) {
        sealed.style.setProperty('--vx-charge-ms', REVEAL_CHARGE_MS + 'ms');
        sealed.classList.add('is-charging');
      }
      $('[data-vx-reveal]').prop('disabled', true);
      $('[data-vx-reveal-label]').text(revealState.noun === 'item' ? 'Opening…' : 'Grading…');
      var state = revealState;
      setTimeout(function () {
        if (state !== revealState) return;
        state.chargeDone = true;
        if (state.ready) finishSealed();
      }, REVEAL_CHARGE_MS);
    }

    function finishSealed() {
      revealState.phase = 'done';
      var tone = pendingTone || { tone: 'silver', level: 0 };
      setTone(tone.tone, tone.level);
      flashPage();
      playWhoosh();
      setTimeout(function () {
        endSealed();
        revealResult('success', true);
        track('reveal_open', articleInfo());
      }, REDUCED_MOTION ? 0 : 180);
    }

    function replayReveal() {
      if (!revealState) return;
      closeShareSheet();
      var info = articleInfo();
      track('reveal_replay', { cert: info.cert, kind: info.kind });
      var cert = info.cert;
      var title = pendingTitle;
      showSealed(cert);
      revealState.ready = true;
      pendingTitle = title;
      window.scrollTo(0, 0);
    }

    function removeNoFlashStyles() {
      var els = document.querySelectorAll('[id="swau-no-flash"]');
      for (var i = 0; i < els.length; i++) {
        els[i].parentNode.removeChild(els[i]);
      }
    }

    function showLoading(label) {
      removeNoFlashStyles();
      clearTimeout(resultTimer);
      pendingTone = null;
      setTone('silver', 0);
      setResultMode(true, label);
      $('.swau-card').hide();
      $('.swau-authentication-success--container').hide();
      $('.swau-authentication-error--container').hide();
      var charge = document.querySelector('.vx-charge span');
      if (charge) {
        charge.style.animation = 'none';
        void charge.offsetWidth;
        charge.style.animation = '';
      }
      $('.swau-loading-container').show();
      loadingStartedAt = now();
    }

    function hideLoading() {
      $('.swau-loading-container').hide();
    }

    function showResult(type) {
      if (revealState && revealState.phase !== 'done') {
        // Nothing to unseal for a miss or an outage, so those show straight away.
        if (type !== 'success') {
          endSealed();
          revealResult(type);
          return;
        }
        revealState.ready = true;
        if (revealState.phase === 'charging' && revealState.chargeDone) finishSealed();
        return;
      }
      clearTimeout(resultTimer);
      var wait = loadingStartedAt ? Math.max(0, MIN_SWEEP_MS - (now() - loadingStartedAt)) : 0;
      resultTimer = setTimeout(function () { revealResult(type); }, wait);
    }

    function revealResult(type, fromSeal) {
      loadingStartedAt = 0;
      hideLoading();
      removeNoFlashStyles();
      $('.swau-card').hide();
      var tone = pendingTone || { tone: 'silver', level: 0 };
      setTone(tone.tone, tone.level);
      var $success = $('.swau-authentication-success--container');
      var $error = $('.swau-authentication-error--container');
      var $shown = type === 'success' ? $success : $error;
      if (type === 'success') {
        $error.hide();
        $success.show();
      } else {
        $success.hide();
        $error.show();
      }
      document.title = pendingTitle || DEFAULT_TITLE;
      window.scrollTo(0, 0);
      var heading = $shown.find('h1').first()[0];
      if (heading) {
        try { heading.focus({ preventScroll: true }); } catch (e) { heading.focus(); }
      }
      if (type === 'success') playReveal(tone, fromSeal);
    }

    function showForm() {
      closeShareSheet();
      removeNoFlashStyles();
      clearTimeout(resultTimer);
      loadingStartedAt = 0;
      if (revealState) endSealed();
      revealState = null;
      var sound = document.querySelector('[data-vx-sound]');
      if (sound) sound.hidden = true;
      pendingTone = null;
      pendingTitle = '';
      setTone('silver', 0);
      setResultMode(false, '');
      $('.swau-authentication-success--container').hide().removeClass('card-report-mode verification-results-mode record-mode').empty();
      $('.swau-authentication-error--container').hide().empty();
      $('.swau-loading-container').hide();
      $('.swau-card').show();
      var $form = $('#swau-authentication-form');
      if ($form.length) $form[0].reset();
      $('#swau-authentication-form .error').hide();
      document.title = DEFAULT_TITLE;
      setIdParam(null);
      window.scrollTo(0, 0);
    }

    // ── Share, download, toast ────────────────────────────────────────────────

    function toast(message) {
      var el = document.querySelector('.vx-toast');
      if (!el) return;
      el.textContent = message;
      el.classList.add('is-on');
      clearTimeout(toast.timer);
      toast.timer = setTimeout(function () { el.classList.remove('is-on'); }, 2400);
    }

    function copyText(text) {
      function legacyCopy() {
        return new Promise(function (resolve, reject) {
          var active = document.activeElement;
          var ta = document.createElement('textarea');
          ta.value = text;
          ta.setAttribute('readonly', '');
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          try {
            if (document.execCommand('copy')) resolve();
            else reject(new Error('copy failed'));
          } catch (err) {
            reject(err);
          }
          document.body.removeChild(ta);
          if (active && active.focus) active.focus();
        });
      }
      // In-app browsers often expose navigator.clipboard but reject every write.
      if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text).catch(legacyCopy);
      return legacyCopy();
    }

    // ── Analytics ─────────────────────────────────────────────────────────────

    // Same event names the app.swau.com reveal page sent, so existing reports keep working.
    // Outside reveal mode shares use GA's recommended `share` event.
    function track(event, params) {
      if (typeof window.gtag !== 'function') return;
      try { window.gtag('event', event, params); } catch (e) {}
    }

    function articleInfo(article) {
      article = article || document.querySelector('.swau-authentication-success--container .vx');
      return {
        cert: article ? article.getAttribute('data-cert') || '' : '',
        kind: article ? article.getAttribute('data-kind') || '' : '',
        grade: article ? article.getAttribute('data-grade') || '' : ''
      };
    }

    function trackShare(info, method, size) {
      if (revealState) {
        var params = { cert: info.cert, kind: info.kind, method: method };
        if (size) params.size = size;
        track(size ? 'reveal_save_image' : 'reveal_share', params);
      } else {
        track('share', { method: size ? 'save_' + size + '_' + method : method, content_type: info.kind, item_id: info.cert });
      }
    }

    // ── Share sheet ───────────────────────────────────────────────────────────

    var sheet = null;

    function shareImageUrl(cert, size) {
      return SHARE_BASE_URL + encodeURIComponent(cert) + '/image?size=' + size;
    }

    // iOS only opens the share sheet straight from a tap, so the images are fetched when the sheet opens.
    function fetchShareImage(cert, size) {
      if (!window.fetch || typeof File === 'undefined') return Promise.reject(new Error('unsupported'));
      return fetch(shareImageUrl(cert, size), { mode: 'cors' }).then(function (res) {
        if (!res.ok) throw new Error('image failed');
        return res.blob();
      }).then(function (blob) {
        return new File([blob], 'SWAU-' + cert + '-' + size + '.png', { type: 'image/png' });
      });
    }

    function sheetButton(action, icon, label) {
      return '<button type="button" class="vx-sheet__btn" data-vx-sheet="' + action + '">' + ICONS[icon] + '<span>' + label + '</span></button>';
    }

    function openShareSheet(article) {
      closeShareSheet();
      var info = articleInfo(article);
      if (!info.cert) return;
      var title = $(article).find('.vx-title').first().text() || 'SWAU record';
      var url = SHARE_BASE_URL + encodeURIComponent(info.cert);
      var text = article.getAttribute('data-share-text') || title + (info.grade ? ' — ' + info.grade : '') + '\nSWAU #' + info.cert;
      var canNative = typeof navigator.share === 'function';

      var html = '<div class="vx-sheet" role="dialog" aria-modal="true" aria-labelledby="vx-sheet-title">';
      html += '<button type="button" class="vx-sheet__scrim" data-vx-sheet="close" aria-label="Close share sheet"></button>';
      html += '<div class="vx-sheet__panel">';
      html += '<div class="vx-sheet__head">';
      html += '<img class="vx-sheet__preview" src="' + escapeHtml(shareImageUrl(info.cert, 'post')) + '" alt="Share image preview">';
      html += '<div class="vx-sheet__meta"><p class="vx-sheet__title" id="vx-sheet-title">' + (revealState ? 'Share this reveal' : 'Share this record') + '</p>';
      html += '<p class="vx-sheet__name">' + escapeHtml(title) + '</p>';
      html += '<p class="vx-sheet__cert">SWAU #' + escapeHtml(info.cert) + '</p></div>';
      html += '<button type="button" class="vx-sheet__close" data-vx-sheet="close" aria-label="Close">' + ICONS.cross + '</button>';
      html += '</div><div class="vx-sheet__list">';
      if (canNative) html += sheetButton('native', 'share', 'Share…');
      html += sheetButton('copy', 'link', 'Copy link');
      html += sheetButton('post', 'download', 'Save share image');
      html += sheetButton('story', 'story', 'Save story image');
      html += '<div class="vx-sheet__row">';
      html += '<a class="vx-sheet__btn" data-vx-sheet="x" target="_blank" rel="noopener noreferrer" href="https://twitter.com/intent/tweet?text='
           + encodeURIComponent(text + '\n' + url) + '">' + ICONS.x + '<span>Post on X</span></a>';
      html += '<a class="vx-sheet__btn" data-vx-sheet="facebook" target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/sharer/sharer.php?u='
           + encodeURIComponent(url) + '">' + ICONS.facebook + '<span>Facebook</span></a>';
      html += '</div></div><p class="vx-sheet__error" role="alert"></p></div></div>';

      var el = $(html).appendTo('.swau-verify-page')[0];
      sheet = {
        el: el, info: info, title: title, url: url, text: text, files: {}, opener: document.activeElement,
        shareTitle: article.getAttribute('data-share-title') || title + ' · SWAU'
      };
      var current = sheet;
      ['post', 'story'].forEach(function (size) {
        fetchShareImage(info.cert, size).then(function (file) { current.files[size] = file; }, function () {});
      });
      document.body.classList.add('vx-sheet-open');
      var firstBtn = el.querySelector('.vx-sheet__btn');
      if (firstBtn) firstBtn.focus();
    }

    function closeShareSheet() {
      if (!sheet) return;
      var opener = sheet.opener;
      $(sheet.el).remove();
      sheet = null;
      document.body.classList.remove('vx-sheet-open');
      if (opener && opener.focus) opener.focus();
    }

    function sheetError(message) {
      if (!sheet) return;
      sheet.el.querySelector('.vx-sheet__error').textContent = message;
    }

    function saveShareImage(size) {
      var s = sheet;
      sheetError('');
      var ready = s.files[size];
      // Phones get the system sheet (Save to Photos, Instagram, Messages); a download would land in Files.
      var touch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      if (ready && touch && navigator.canShare && navigator.canShare({ files: [ready] })) {
        navigator.share({ files: [ready], title: s.shareTitle }).then(function () {
          trackShare(s.info, 'share', size);
        }, function (err) {
          if (!err || err.name !== 'AbortError') sheetError('Could not open the share sheet.');
        });
        return;
      }
      var button = s.el.querySelector('[data-vx-sheet="' + size + '"] span');
      var label = button ? button.textContent : '';
      if (button) button.textContent = 'Saving…';
      (ready ? Promise.resolve(ready) : fetchShareImage(s.info.cert, size)).then(function (file) {
        var href = URL.createObjectURL(file);
        var a = document.createElement('a');
        a.href = href;
        a.download = file.name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(function () { URL.revokeObjectURL(href); }, 1000);
        trackShare(s.info, 'download', size);
      }, function () {
        sheetError('Could not save the image. Try again in a moment.');
      }).then(function () {
        if (button) button.textContent = label;
      });
    }

    $(document).on('click', '[data-vx-share]', function () {
      var article = $(this).closest('.vx')[0];
      if (article) openShareSheet(article);
    });

    $(document).on('click', '[data-vx-sheet]', function (e) {
      if (!sheet) return;
      var action = this.getAttribute('data-vx-sheet');
      var s = sheet;
      sheetError('');
      if (action === 'close') {
        closeShareSheet();
      } else if (action === 'native') {
        navigator.share({ title: s.shareTitle, text: s.text, url: s.url }).then(function () {
          trackShare(s.info, 'native');
          closeShareSheet();
        }, function (err) {
          if (!err || err.name !== 'AbortError') sheetError('Could not open the share sheet.');
        });
      } else if (action === 'copy') {
        var span = this.querySelector('span');
        copyText(s.url).then(function () {
          trackShare(s.info, 'copy');
          span.textContent = 'Link copied';
          setTimeout(function () { span.textContent = 'Copy link'; }, 1600);
        }, function () { sheetError('Could not copy the link.'); });
      } else if (action === 'post' || action === 'story') {
        saveShareImage(action);
      } else {
        trackShare(s.info, action);
      }
    });

    $(document).on('keydown', function (e) {
      if (sheet && e.key === 'Escape') closeShareSheet();
    });

    $(document).on('click', '[data-vx-download]', function () {
      var stage = $(this).closest('.vx').find('.vx-stage')[0];
      if (!stage) return;
      var slides = stage.querySelectorAll('.vx-slide');
      var slide = slides[Number(stage.getAttribute('data-index') || 0)] || slides[0];
      if (!slide) return;
      var url = slide.getAttribute('data-full');
      downloadSlabPhoto(url, fileNameFor(url));
    });

    $(document).on('click', '[data-vx-zoom]', function () {
      window.cardZoom(this.getAttribute('data-vx-zoom'), Number(this.getAttribute('data-dir')));
    });

    $(document).on('click', '[data-vx-retry]', function () {
      showLoading(lookupLabel($('#hologramNumber').val()));
      authenticate();
    });

    function checkPosted() {
      if (typeof URLSearchParams === 'undefined') return;
      var urlParams = new URLSearchParams(window.location.search);
      if (!urlParams.has('id')) return;
      var hologramNumber = String(urlParams.get('id') || '').trim();
      $('#hologramNumber').val(hologramNumber);
      if (REVEAL_MODE && hologramNumber && hologramNumber.charAt(0) !== '#') showSealed(hologramNumber);
      else showLoading(lookupLabel(hologramNumber));
      authenticate();
    }

    $(document).on('click', '[data-vx-reveal]', startCharge);

    $(document).on('click', '[data-vx-replay]', replayReveal);

    $(document).on('click', '[data-vx-sound]', function () {
      var on = !soundOn();
      try { localStorage.setItem(SOUND_KEY, on ? '1' : '0'); } catch (e) {}
      this.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) unlockAudio();
    });

    $(document).on('click', '.verify-another-item-btn', function(){
      showForm();
      $('#hologramNumber').trigger('focus');
    });

    $(document).on('submit', '#swau-authentication-form', function(e){
      e.preventDefault();
      $('#swau-authentication-form .error').hide();
      var raw = String($('#hologramNumber').val() || '').trim();
      if (!raw || raw === '#') {
        showInlineError(raw === '#' ? 'Add your order number after the #.' : 'Enter the number from your hologram or slab label.');
        return false;
      }
      // Keep the cert in the address bar so a refresh or a copied link opens the same record.
      if (raw.charAt(0) !== '#') setIdParam(raw.replace(/\s+/g, '').toUpperCase());
      showLoading(lookupLabel(raw));
      authenticate();
      return false;
    });

      // Initialize when DOM is ready
      $(document).ready(function() {
        checkPosted();
      });
    }

    // Check if jQuery is available, if not wait for it
    if (typeof jQuery !== 'undefined') {
      initSWAUAuth();
    } else {
      // Wait for jQuery to load
      var checkJQuery = setInterval(function() {
        if (typeof jQuery !== 'undefined') {
          clearInterval(checkJQuery);
          initSWAUAuth();
        }
      }, 100);
    }
  })();
